
// * @Author: zql
// * @Date: 2024/12/9 17:05


export default [
    {
        "date": "2024/12/09",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 20675.33,
        "impressions": 16269,
        "ecpm": 1270.84,
        "taps": 8392,
        "imp_click_rate": "51.58%",
        "cli_price": 2.46,
        "installs": 6686,
        "cli_installs_rate": "79.67%",
        "installs_price": 3.09
    },
    {
        "date": "2024/12/09",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 514.5,
        "impressions": 385,
        "ecpm": 1336.37,
        "taps": 190,
        "imp_click_rate": "49.35%",
        "cli_price": 2.71,
        "installs": 149,
        "cli_installs_rate": "78.42%",
        "installs_price": 3.45
    },
    {
        "date": "2024/12/09",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 323.84,
        "impressions": 184,
        "ecpm": 1760,
        "taps": 106,
        "imp_click_rate": "57.61%",
        "cli_price": 3.06,
        "installs": 88,
        "cli_installs_rate": "83.02%",
        "installs_price": 3.68
    },
    {
        "date": "2024/12/09",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 7.77,
        "impressions": 3,
        "ecpm": 2590.13,
        "taps": 2,
        "imp_click_rate": "66.67%",
        "cli_price": 3.89,
        "installs": 1,
        "cli_installs_rate": "50.00%",
        "installs_price": 7.77
    },
    {
        "date": "2024/12/09",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 8641.49,
        "impressions": 3750,
        "ecpm": 2304.4,
        "taps": 528,
        "imp_click_rate": "14.08%",
        "cli_price": 16.37,
        "installs": 430,
        "cli_installs_rate": "81.44%",
        "installs_price": 20.1
    },
    {
        "date": "2024/12/09",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 163.88,
        "impressions": 469,
        "ecpm": 349.42,
        "taps": 11,
        "imp_click_rate": "2.35%",
        "cli_price": 14.9,
        "installs": 9,
        "cli_installs_rate": "81.82%",
        "installs_price": 18.21
    },
    {
        "date": "2024/12/09",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1669.84,
        "impressions": 1294,
        "ecpm": 1290.45,
        "taps": 162,
        "imp_click_rate": "12.52%",
        "cli_price": 10.31,
        "installs": 125,
        "cli_installs_rate": "77.16%",
        "installs_price": 13.36
    },
    {
        "date": "2024/12/09",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 30.76,
        "impressions": 43,
        "ecpm": 715.28,
        "taps": 4,
        "imp_click_rate": "9.30%",
        "cli_price": 7.69,
        "installs": 4,
        "cli_installs_rate": "100.00%",
        "installs_price": 7.69
    },
    {
        "date": "2024/12/09",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 435.85,
        "impressions": 1073,
        "ecpm": 406.2,
        "taps": 29,
        "imp_click_rate": "2.70%",
        "cli_price": 15.03,
        "installs": 17,
        "cli_installs_rate": "58.62%",
        "installs_price": 25.64
    },
    {
        "date": "2024/12/09",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 0,
        "impressions": 55,
        "ecpm": 0,
        "taps": 0,
        "imp_click_rate": "0.00%",
        "cli_price": 0,
        "installs": 0,
        "cli_installs_rate": "0.00%",
        "installs_price": 0
    },
    {
        "date": "2024/12/09",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 248.37,
        "impressions": 530,
        "ecpm": 468.63,
        "taps": 16,
        "imp_click_rate": "3.02%",
        "cli_price": 15.52,
        "installs": 10,
        "cli_installs_rate": "62.50%",
        "installs_price": 24.84
    },
    {
        "date": "2024/12/09",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 0,
        "impressions": 8,
        "ecpm": 0,
        "taps": 0,
        "imp_click_rate": "0.00%",
        "cli_price": 0,
        "installs": 0,
        "cli_installs_rate": "0.00%",
        "installs_price": 0
    },
    {
        "date": "2024/12/08",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 67647.25,
        "impressions": 53458,
        "ecpm": 1265.43,
        "taps": 27825,
        "imp_click_rate": "52.05%",
        "cli_price": 2.43,
        "installs": 22956,
        "cli_installs_rate": "82.50%",
        "installs_price": 2.95
    },
    {
        "date": "2024/12/08",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1609.74,
        "impressions": 1262,
        "ecpm": 1275.54,
        "taps": 612,
        "imp_click_rate": "48.49%",
        "cli_price": 2.63,
        "installs": 504,
        "cli_installs_rate": "82.35%",
        "installs_price": 3.19
    },
    {
        "date": "2024/12/08",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 935.34,
        "impressions": 556,
        "ecpm": 1682.26,
        "taps": 308,
        "imp_click_rate": "55.40%",
        "cli_price": 3.04,
        "installs": 261,
        "cli_installs_rate": "84.74%",
        "installs_price": 3.58
    },
    {
        "date": "2024/12/08",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 22.93,
        "impressions": 11,
        "ecpm": 2084.93,
        "taps": 7,
        "imp_click_rate": "63.64%",
        "cli_price": 3.28,
        "installs": 7,
        "cli_installs_rate": "100.00%",
        "installs_price": 3.28
    },
    {
        "date": "2024/12/08",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 22309.63,
        "impressions": 13250,
        "ecpm": 1683.75,
        "taps": 1971,
        "imp_click_rate": "14.88%",
        "cli_price": 11.32,
        "installs": 1591,
        "cli_installs_rate": "80.72%",
        "installs_price": 14.02
    },
    {
        "date": "2024/12/08",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 955.08,
        "impressions": 7568,
        "ecpm": 126.2,
        "taps": 54,
        "imp_click_rate": "0.71%",
        "cli_price": 17.69,
        "installs": 26,
        "cli_installs_rate": "48.15%",
        "installs_price": 36.73
    },
    {
        "date": "2024/12/08",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 4072.36,
        "impressions": 5385,
        "ecpm": 756.24,
        "taps": 506,
        "imp_click_rate": "9.40%",
        "cli_price": 8.05,
        "installs": 383,
        "cli_installs_rate": "75.69%",
        "installs_price": 10.63
    },
    {
        "date": "2024/12/08",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 24.38,
        "impressions": 351,
        "ecpm": 69.46,
        "taps": 4,
        "imp_click_rate": "1.14%",
        "cli_price": 6.1,
        "installs": 2,
        "cli_installs_rate": "50.00%",
        "installs_price": 12.19
    },
    {
        "date": "2024/12/08",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 2396.28,
        "impressions": 3694,
        "ecpm": 648.69,
        "taps": 154,
        "imp_click_rate": "4.17%",
        "cli_price": 15.56,
        "installs": 92,
        "cli_installs_rate": "59.74%",
        "installs_price": 26.05
    },
    {
        "date": "2024/12/08",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 39.62,
        "impressions": 104,
        "ecpm": 380.99,
        "taps": 3,
        "imp_click_rate": "2.88%",
        "cli_price": 13.21,
        "installs": 2,
        "cli_installs_rate": "66.67%",
        "installs_price": 19.81
    },
    {
        "date": "2024/12/08",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 2245.54,
        "impressions": 2929,
        "ecpm": 766.66,
        "taps": 143,
        "imp_click_rate": "4.88%",
        "cli_price": 15.7,
        "installs": 97,
        "cli_installs_rate": "67.83%",
        "installs_price": 23.15
    },
    {
        "date": "2024/12/08",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 51.84,
        "impressions": 67,
        "ecpm": 773.74,
        "taps": 3,
        "imp_click_rate": "4.48%",
        "cli_price": 17.28,
        "installs": 2,
        "cli_installs_rate": "66.67%",
        "installs_price": 25.92
    },
    {
        "date": "2024/12/07",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 64846.93,
        "impressions": 51735,
        "ecpm": 1253.44,
        "taps": 26919,
        "imp_click_rate": "52.03%",
        "cli_price": 2.41,
        "installs": 22207,
        "cli_installs_rate": "82.50%",
        "installs_price": 2.92
    },
    {
        "date": "2024/12/07",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1591.09,
        "impressions": 1241,
        "ecpm": 1282.11,
        "taps": 614,
        "imp_click_rate": "49.48%",
        "cli_price": 2.59,
        "installs": 495,
        "cli_installs_rate": "80.62%",
        "installs_price": 3.21
    },
    {
        "date": "2024/12/07",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1107.99,
        "impressions": 605,
        "ecpm": 1831.39,
        "taps": 353,
        "imp_click_rate": "58.35%",
        "cli_price": 3.14,
        "installs": 291,
        "cli_installs_rate": "82.44%",
        "installs_price": 3.81
    },
    {
        "date": "2024/12/07",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 28.11,
        "impressions": 17,
        "ecpm": 1653.41,
        "taps": 9,
        "imp_click_rate": "52.94%",
        "cli_price": 3.12,
        "installs": 8,
        "cli_installs_rate": "88.89%",
        "installs_price": 3.51
    },
    {
        "date": "2024/12/07",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 22948.22,
        "impressions": 12064,
        "ecpm": 1902.21,
        "taps": 1790,
        "imp_click_rate": "14.84%",
        "cli_price": 12.82,
        "installs": 1421,
        "cli_installs_rate": "79.39%",
        "installs_price": 16.15
    },
    {
        "date": "2024/12/07",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 859.51,
        "impressions": 1504,
        "ecpm": 571.49,
        "taps": 65,
        "imp_click_rate": "4.32%",
        "cli_price": 13.22,
        "installs": 29,
        "cli_installs_rate": "44.62%",
        "installs_price": 29.64
    },
    {
        "date": "2024/12/07",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 3832.7,
        "impressions": 5105,
        "ecpm": 750.77,
        "taps": 457,
        "imp_click_rate": "8.95%",
        "cli_price": 8.39,
        "installs": 364,
        "cli_installs_rate": "79.65%",
        "installs_price": 10.53
    },
    {
        "date": "2024/12/07",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 51.81,
        "impressions": 362,
        "ecpm": 143.12,
        "taps": 5,
        "imp_click_rate": "1.38%",
        "cli_price": 10.36,
        "installs": 5,
        "cli_installs_rate": "100.00%",
        "installs_price": 10.36
    },
    {
        "date": "2024/12/07",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 2515.77,
        "impressions": 4014,
        "ecpm": 626.75,
        "taps": 161,
        "imp_click_rate": "4.01%",
        "cli_price": 15.63,
        "installs": 112,
        "cli_installs_rate": "69.57%",
        "installs_price": 22.46
    },
    {
        "date": "2024/12/07",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 30.45,
        "impressions": 147,
        "ecpm": 207.13,
        "taps": 2,
        "imp_click_rate": "1.36%",
        "cli_price": 15.22,
        "installs": 1,
        "cli_installs_rate": "50.00%",
        "installs_price": 30.45
    },
    {
        "date": "2024/12/07",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1832.76,
        "impressions": 2106,
        "ecpm": 870.26,
        "taps": 119,
        "imp_click_rate": "5.65%",
        "cli_price": 15.4,
        "installs": 84,
        "cli_installs_rate": "70.59%",
        "installs_price": 21.82
    },
    {
        "date": "2024/12/07",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 13.41,
        "impressions": 41,
        "ecpm": 327.15,
        "taps": 1,
        "imp_click_rate": "2.44%",
        "cli_price": 13.41,
        "installs": 1,
        "cli_installs_rate": "100.00%",
        "installs_price": 13.41
    },
    {
        "date": "2024/12/06",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 67914.91,
        "impressions": 54502,
        "ecpm": 1246.1,
        "taps": 28337,
        "imp_click_rate": "51.99%",
        "cli_price": 2.4,
        "installs": 23376,
        "cli_installs_rate": "82.49%",
        "installs_price": 2.91
    },
    {
        "date": "2024/12/06",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1544.27,
        "impressions": 1193,
        "ecpm": 1294.44,
        "taps": 580,
        "imp_click_rate": "48.62%",
        "cli_price": 2.66,
        "installs": 474,
        "cli_installs_rate": "81.72%",
        "installs_price": 3.26
    },
    {
        "date": "2024/12/06",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1209.92,
        "impressions": 643,
        "ecpm": 1881.68,
        "taps": 357,
        "imp_click_rate": "55.52%",
        "cli_price": 3.39,
        "installs": 303,
        "cli_installs_rate": "84.87%",
        "installs_price": 3.99
    },
    {
        "date": "2024/12/06",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 70.18,
        "impressions": 29,
        "ecpm": 2420.06,
        "taps": 19,
        "imp_click_rate": "65.52%",
        "cli_price": 3.69,
        "installs": 17,
        "cli_installs_rate": "89.47%",
        "installs_price": 4.13
    },
    {
        "date": "2024/12/06",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 22792.44,
        "impressions": 14155,
        "ecpm": 1610.2,
        "taps": 2021,
        "imp_click_rate": "14.28%",
        "cli_price": 11.28,
        "installs": 1639,
        "cli_installs_rate": "81.10%",
        "installs_price": 13.91
    },
    {
        "date": "2024/12/06",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 290.25,
        "impressions": 3820,
        "ecpm": 75.98,
        "taps": 28,
        "imp_click_rate": "0.73%",
        "cli_price": 10.37,
        "installs": 25,
        "cli_installs_rate": "89.29%",
        "installs_price": 11.61
    },
    {
        "date": "2024/12/06",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 3600.37,
        "impressions": 5147,
        "ecpm": 699.51,
        "taps": 443,
        "imp_click_rate": "8.61%",
        "cli_price": 8.13,
        "installs": 338,
        "cli_installs_rate": "76.30%",
        "installs_price": 10.65
    },
    {
        "date": "2024/12/06",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 100.82,
        "impressions": 565,
        "ecpm": 178.44,
        "taps": 14,
        "imp_click_rate": "2.48%",
        "cli_price": 7.2,
        "installs": 9,
        "cli_installs_rate": "64.29%",
        "installs_price": 11.2
    },
    {
        "date": "2024/12/06",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 3181.25,
        "impressions": 4627,
        "ecpm": 687.54,
        "taps": 192,
        "imp_click_rate": "4.15%",
        "cli_price": 16.57,
        "installs": 120,
        "cli_installs_rate": "62.50%",
        "installs_price": 26.51
    },
    {
        "date": "2024/12/06",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 54.11,
        "impressions": 153,
        "ecpm": 353.66,
        "taps": 4,
        "imp_click_rate": "2.61%",
        "cli_price": 13.53,
        "installs": 2,
        "cli_installs_rate": "50.00%",
        "installs_price": 27.06
    },
    {
        "date": "2024/12/06",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 2126.5,
        "impressions": 2686,
        "ecpm": 791.7,
        "taps": 135,
        "imp_click_rate": "5.03%",
        "cli_price": 15.75,
        "installs": 97,
        "cli_installs_rate": "71.85%",
        "installs_price": 21.92
    },
    {
        "date": "2024/12/06",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 33.41,
        "impressions": 28,
        "ecpm": 1193.15,
        "taps": 2,
        "imp_click_rate": "7.14%",
        "cli_price": 16.7,
        "installs": 2,
        "cli_installs_rate": "100.00%",
        "installs_price": 16.7
    },
    {
        "date": "2024/12/05",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 74852.66,
        "impressions": 56757,
        "ecpm": 1318.83,
        "taps": 28951,
        "imp_click_rate": "51.01%",
        "cli_price": 2.59,
        "installs": 23758,
        "cli_installs_rate": "82.06%",
        "installs_price": 3.15
    },
    {
        "date": "2024/12/05",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1751.98,
        "impressions": 1322,
        "ecpm": 1325.25,
        "taps": 644,
        "imp_click_rate": "48.71%",
        "cli_price": 2.72,
        "installs": 524,
        "cli_installs_rate": "81.37%",
        "installs_price": 3.34
    },
    {
        "date": "2024/12/05",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1221.28,
        "impressions": 661,
        "ecpm": 1847.62,
        "taps": 386,
        "imp_click_rate": "58.40%",
        "cli_price": 3.16,
        "installs": 320,
        "cli_installs_rate": "82.90%",
        "installs_price": 3.82
    },
    {
        "date": "2024/12/05",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 40.89,
        "impressions": 21,
        "ecpm": 1947.24,
        "taps": 11,
        "imp_click_rate": "52.38%",
        "cli_price": 3.72,
        "installs": 11,
        "cli_installs_rate": "100.00%",
        "installs_price": 3.72
    },
    {
        "date": "2024/12/05",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 24773.04,
        "impressions": 15541,
        "ecpm": 1594.04,
        "taps": 2191,
        "imp_click_rate": "14.10%",
        "cli_price": 11.31,
        "installs": 1757,
        "cli_installs_rate": "80.19%",
        "installs_price": 14.1
    },
    {
        "date": "2024/12/05",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 508.34,
        "impressions": 1199,
        "ecpm": 423.97,
        "taps": 56,
        "imp_click_rate": "4.67%",
        "cli_price": 9.08,
        "installs": 31,
        "cli_installs_rate": "55.36%",
        "installs_price": 16.4
    },
    {
        "date": "2024/12/05",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 3662.45,
        "impressions": 5661,
        "ecpm": 646.96,
        "taps": 482,
        "imp_click_rate": "8.51%",
        "cli_price": 7.6,
        "installs": 362,
        "cli_installs_rate": "75.10%",
        "installs_price": 10.12
    },
    {
        "date": "2024/12/05",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 58.56,
        "impressions": 381,
        "ecpm": 153.7,
        "taps": 9,
        "imp_click_rate": "2.36%",
        "cli_price": 6.51,
        "installs": 5,
        "cli_installs_rate": "55.56%",
        "installs_price": 11.71
    },
    {
        "date": "2024/12/05",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 5179.88,
        "impressions": 7157,
        "ecpm": 723.75,
        "taps": 310,
        "imp_click_rate": "4.33%",
        "cli_price": 16.71,
        "installs": 194,
        "cli_installs_rate": "62.58%",
        "installs_price": 26.7
    },
    {
        "date": "2024/12/05",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 108.52,
        "impressions": 197,
        "ecpm": 550.86,
        "taps": 8,
        "imp_click_rate": "4.06%",
        "cli_price": 13.56,
        "installs": 3,
        "cli_installs_rate": "37.50%",
        "installs_price": 36.17
    },
    {
        "date": "2024/12/05",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1973.83,
        "impressions": 2878,
        "ecpm": 685.83,
        "taps": 124,
        "imp_click_rate": "4.31%",
        "cli_price": 15.92,
        "installs": 75,
        "cli_installs_rate": "60.48%",
        "installs_price": 26.32
    },
    {
        "date": "2024/12/05",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 53.8,
        "impressions": 94,
        "ecpm": 572.38,
        "taps": 4,
        "imp_click_rate": "4.26%",
        "cli_price": 13.45,
        "installs": 2,
        "cli_installs_rate": "50.00%",
        "installs_price": 26.9
    },
    {
        "date": "2024/12/04",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 74743.74,
        "impressions": 58143,
        "ecpm": 1285.52,
        "taps": 29998,
        "imp_click_rate": "51.59%",
        "cli_price": 2.49,
        "installs": 24870,
        "cli_installs_rate": "82.91%",
        "installs_price": 3.01
    },
    {
        "date": "2024/12/04",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1766.07,
        "impressions": 1343,
        "ecpm": 1315.02,
        "taps": 652,
        "imp_click_rate": "48.55%",
        "cli_price": 2.71,
        "installs": 537,
        "cli_installs_rate": "82.36%",
        "installs_price": 3.29
    },
    {
        "date": "2024/12/04",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1247.9,
        "impressions": 673,
        "ecpm": 1854.23,
        "taps": 383,
        "imp_click_rate": "56.91%",
        "cli_price": 3.26,
        "installs": 330,
        "cli_installs_rate": "86.16%",
        "installs_price": 3.78
    },
    {
        "date": "2024/12/04",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 84.04,
        "impressions": 35,
        "ecpm": 2401.19,
        "taps": 22,
        "imp_click_rate": "62.86%",
        "cli_price": 3.82,
        "installs": 20,
        "cli_installs_rate": "90.91%",
        "installs_price": 4.2
    },
    {
        "date": "2024/12/04",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 25594.55,
        "impressions": 13593,
        "ecpm": 1882.92,
        "taps": 1857,
        "imp_click_rate": "13.66%",
        "cli_price": 13.78,
        "installs": 1485,
        "cli_installs_rate": "79.97%",
        "installs_price": 17.24
    },
    {
        "date": "2024/12/04",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 491.05,
        "impressions": 2386,
        "ecpm": 205.81,
        "taps": 39,
        "imp_click_rate": "1.63%",
        "cli_price": 12.59,
        "installs": 34,
        "cli_installs_rate": "87.18%",
        "installs_price": 14.44
    },
    {
        "date": "2024/12/04",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 3662.08,
        "impressions": 4986,
        "ecpm": 734.47,
        "taps": 456,
        "imp_click_rate": "9.15%",
        "cli_price": 8.03,
        "installs": 356,
        "cli_installs_rate": "78.07%",
        "installs_price": 10.29
    },
    {
        "date": "2024/12/04",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 93.16,
        "impressions": 390,
        "ecpm": 238.87,
        "taps": 10,
        "imp_click_rate": "2.56%",
        "cli_price": 9.32,
        "installs": 5,
        "cli_installs_rate": "50.00%",
        "installs_price": 18.63
    },
    {
        "date": "2024/12/04",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 5277.57,
        "impressions": 8690,
        "ecpm": 607.32,
        "taps": 315,
        "imp_click_rate": "3.62%",
        "cli_price": 16.75,
        "installs": 203,
        "cli_installs_rate": "64.44%",
        "installs_price": 26
    },
    {
        "date": "2024/12/04",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 125.42,
        "impressions": 272,
        "ecpm": 461.1,
        "taps": 8,
        "imp_click_rate": "2.94%",
        "cli_price": 15.68,
        "installs": 6,
        "cli_installs_rate": "75.00%",
        "installs_price": 20.9
    },
    {
        "date": "2024/12/04",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 2536.45,
        "impressions": 3329,
        "ecpm": 761.92,
        "taps": 159,
        "imp_click_rate": "4.78%",
        "cli_price": 15.95,
        "installs": 110,
        "cli_installs_rate": "69.18%",
        "installs_price": 23.06
    },
    {
        "date": "2024/12/04",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 17.06,
        "impressions": 55,
        "ecpm": 310.27,
        "taps": 1,
        "imp_click_rate": "1.82%",
        "cli_price": 17.06,
        "installs": 0,
        "cli_installs_rate": "0.00%",
        "installs_price": 0
    },
    {
        "date": "2024/12/03",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 76383.34,
        "impressions": 59423,
        "ecpm": 1285.42,
        "taps": 30659,
        "imp_click_rate": "51.59%",
        "cli_price": 2.49,
        "installs": 25134,
        "cli_installs_rate": "81.98%",
        "installs_price": 3.04
    },
    {
        "date": "2024/12/03",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1703.39,
        "impressions": 1428,
        "ecpm": 1192.85,
        "taps": 632,
        "imp_click_rate": "44.26%",
        "cli_price": 2.7,
        "installs": 511,
        "cli_installs_rate": "80.85%",
        "installs_price": 3.33
    },
    {
        "date": "2024/12/03",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1175.56,
        "impressions": 634,
        "ecpm": 1854.2,
        "taps": 350,
        "imp_click_rate": "55.21%",
        "cli_price": 3.36,
        "installs": 297,
        "cli_installs_rate": "84.86%",
        "installs_price": 3.96
    },
    {
        "date": "2024/12/03",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 35.74,
        "impressions": 21,
        "ecpm": 1701.68,
        "taps": 11,
        "imp_click_rate": "52.38%",
        "cli_price": 3.25,
        "installs": 7,
        "cli_installs_rate": "63.64%",
        "installs_price": 5.11
    },
    {
        "date": "2024/12/03",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 25693.8,
        "impressions": 13224,
        "ecpm": 1942.97,
        "taps": 1783,
        "imp_click_rate": "13.48%",
        "cli_price": 14.41,
        "installs": 1432,
        "cli_installs_rate": "80.31%",
        "installs_price": 17.94
    },
    {
        "date": "2024/12/03",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 434.48,
        "impressions": 7351,
        "ecpm": 59.11,
        "taps": 34,
        "imp_click_rate": "0.46%",
        "cli_price": 12.78,
        "installs": 26,
        "cli_installs_rate": "76.47%",
        "installs_price": 16.71
    },
    {
        "date": "2024/12/03",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 4091.84,
        "impressions": 5212,
        "ecpm": 785.08,
        "taps": 501,
        "imp_click_rate": "9.61%",
        "cli_price": 8.17,
        "installs": 399,
        "cli_installs_rate": "79.64%",
        "installs_price": 10.26
    },
    {
        "date": "2024/12/03",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 99.28,
        "impressions": 867,
        "ecpm": 114.51,
        "taps": 12,
        "imp_click_rate": "1.38%",
        "cli_price": 8.27,
        "installs": 9,
        "cli_installs_rate": "75.00%",
        "installs_price": 11.03
    },
    {
        "date": "2024/12/03",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 6643.61,
        "impressions": 9272,
        "ecpm": 716.52,
        "taps": 389,
        "imp_click_rate": "4.20%",
        "cli_price": 17.08,
        "installs": 240,
        "cli_installs_rate": "61.70%",
        "installs_price": 27.68
    },
    {
        "date": "2024/12/03",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 144.05,
        "impressions": 336,
        "ecpm": 428.71,
        "taps": 9,
        "imp_click_rate": "2.68%",
        "cli_price": 16.01,
        "installs": 5,
        "cli_installs_rate": "55.56%",
        "installs_price": 28.81
    },
    {
        "date": "2024/12/03",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 871.06,
        "impressions": 1653,
        "ecpm": 526.96,
        "taps": 67,
        "imp_click_rate": "4.05%",
        "cli_price": 13,
        "installs": 48,
        "cli_installs_rate": "71.64%",
        "installs_price": 18.15
    },
    {
        "date": "2024/12/03",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 20.88,
        "impressions": 65,
        "ecpm": 321.24,
        "taps": 2,
        "imp_click_rate": "3.08%",
        "cli_price": 10.44,
        "installs": 1,
        "cli_installs_rate": "50.00%",
        "installs_price": 20.88
    },
    {
        "date": "2024/12/02",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 72335.78,
        "impressions": 56269,
        "ecpm": 1285.54,
        "taps": 29140,
        "imp_click_rate": "51.79%",
        "cli_price": 2.48,
        "installs": 23951,
        "cli_installs_rate": "82.19%",
        "installs_price": 3.02
    },
    {
        "date": "2024/12/02",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1694.27,
        "impressions": 1335,
        "ecpm": 1269.12,
        "taps": 622,
        "imp_click_rate": "46.59%",
        "cli_price": 2.72,
        "installs": 509,
        "cli_installs_rate": "81.83%",
        "installs_price": 3.33
    },
    {
        "date": "2024/12/02",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1033.72,
        "impressions": 588,
        "ecpm": 1758.02,
        "taps": 323,
        "imp_click_rate": "54.93%",
        "cli_price": 3.2,
        "installs": 266,
        "cli_installs_rate": "82.35%",
        "installs_price": 3.89
    },
    {
        "date": "2024/12/02",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 44.06,
        "impressions": 37,
        "ecpm": 1190.84,
        "taps": 12,
        "imp_click_rate": "32.43%",
        "cli_price": 3.67,
        "installs": 10,
        "cli_installs_rate": "83.33%",
        "installs_price": 4.41
    },
    {
        "date": "2024/12/02",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 24139.89,
        "impressions": 12968,
        "ecpm": 1861.5,
        "taps": 1788,
        "imp_click_rate": "13.79%",
        "cli_price": 13.5,
        "installs": 1497,
        "cli_installs_rate": "83.72%",
        "installs_price": 16.13
    },
    {
        "date": "2024/12/02",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 516.08,
        "impressions": 9406,
        "ecpm": 54.87,
        "taps": 36,
        "imp_click_rate": "0.38%",
        "cli_price": 14.34,
        "installs": 29,
        "cli_installs_rate": "80.56%",
        "installs_price": 17.8
    },
    {
        "date": "2024/12/02",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 3804,
        "impressions": 4842,
        "ecpm": 785.63,
        "taps": 466,
        "imp_click_rate": "9.62%",
        "cli_price": 8.16,
        "installs": 366,
        "cli_installs_rate": "78.54%",
        "installs_price": 10.39
    },
    {
        "date": "2024/12/02",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 91.34,
        "impressions": 1282,
        "ecpm": 71.25,
        "taps": 9,
        "imp_click_rate": "0.70%",
        "cli_price": 10.15,
        "installs": 3,
        "cli_installs_rate": "33.33%",
        "installs_price": 30.45
    },
    {
        "date": "2024/12/02",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 6931.98,
        "impressions": 8234,
        "ecpm": 841.87,
        "taps": 406,
        "imp_click_rate": "4.93%",
        "cli_price": 17.07,
        "installs": 249,
        "cli_installs_rate": "61.33%",
        "installs_price": 27.84
    },
    {
        "date": "2024/12/02",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 186.54,
        "impressions": 291,
        "ecpm": 641.04,
        "taps": 11,
        "imp_click_rate": "3.78%",
        "cli_price": 16.96,
        "installs": 7,
        "cli_installs_rate": "63.64%",
        "installs_price": 26.65
    },
    {
        "date": "2024/12/02",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1418.64,
        "impressions": 2127,
        "ecpm": 666.97,
        "taps": 95,
        "imp_click_rate": "4.47%",
        "cli_price": 14.93,
        "installs": 62,
        "cli_installs_rate": "65.26%",
        "installs_price": 22.88
    },
    {
        "date": "2024/12/02",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 2.27,
        "impressions": 67,
        "ecpm": 33.89,
        "taps": 1,
        "imp_click_rate": "1.49%",
        "cli_price": 2.27,
        "installs": 0,
        "cli_installs_rate": "0.00%",
        "installs_price": 0
    },
    {
        "date": "2024/12/01",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 70976.33,
        "impressions": 52789,
        "ecpm": 1344.53,
        "taps": 27367,
        "imp_click_rate": "51.84%",
        "cli_price": 2.59,
        "installs": 22555,
        "cli_installs_rate": "82.42%",
        "installs_price": 3.15
    },
    {
        "date": "2024/12/01",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1719.26,
        "impressions": 1249,
        "ecpm": 1376.51,
        "taps": 613,
        "imp_click_rate": "49.08%",
        "cli_price": 2.8,
        "installs": 501,
        "cli_installs_rate": "81.73%",
        "installs_price": 3.43
    },
    {
        "date": "2024/12/01",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1027.21,
        "impressions": 587,
        "ecpm": 1749.94,
        "taps": 317,
        "imp_click_rate": "54.00%",
        "cli_price": 3.24,
        "installs": 266,
        "cli_installs_rate": "83.91%",
        "installs_price": 3.86
    },
    {
        "date": "2024/12/01",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 46.45,
        "impressions": 93,
        "ecpm": 499.42,
        "taps": 15,
        "imp_click_rate": "16.13%",
        "cli_price": 3.1,
        "installs": 10,
        "cli_installs_rate": "66.67%",
        "installs_price": 4.64
    },
    {
        "date": "2024/12/01",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 25712.47,
        "impressions": 11664,
        "ecpm": 2204.43,
        "taps": 1759,
        "imp_click_rate": "15.08%",
        "cli_price": 14.62,
        "installs": 1468,
        "cli_installs_rate": "83.46%",
        "installs_price": 17.52
    },
    {
        "date": "2024/12/01",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 432.11,
        "impressions": 10343,
        "ecpm": 41.78,
        "taps": 31,
        "imp_click_rate": "0.30%",
        "cli_price": 13.94,
        "installs": 25,
        "cli_installs_rate": "80.65%",
        "installs_price": 17.28
    },
    {
        "date": "2024/12/01",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 4335.25,
        "impressions": 4925,
        "ecpm": 880.25,
        "taps": 484,
        "imp_click_rate": "9.83%",
        "cli_price": 8.96,
        "installs": 371,
        "cli_installs_rate": "76.65%",
        "installs_price": 11.69
    },
    {
        "date": "2024/12/01",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 148.16,
        "impressions": 1735,
        "ecpm": 85.39,
        "taps": 14,
        "imp_click_rate": "0.81%",
        "cli_price": 10.58,
        "installs": 10,
        "cli_installs_rate": "71.43%",
        "installs_price": 14.82
    },
    {
        "date": "2024/12/01",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 6291.61,
        "impressions": 8447,
        "ecpm": 744.83,
        "taps": 375,
        "imp_click_rate": "4.44%",
        "cli_price": 16.78,
        "installs": 250,
        "cli_installs_rate": "66.67%",
        "installs_price": 25.17
    },
    {
        "date": "2024/12/01",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 53.22,
        "impressions": 358,
        "ecpm": 148.67,
        "taps": 3,
        "imp_click_rate": "0.84%",
        "cli_price": 17.74,
        "installs": 3,
        "cli_installs_rate": "100.00%",
        "installs_price": 17.74
    },
    {
        "date": "2024/12/01",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 2295.25,
        "impressions": 3130,
        "ecpm": 733.31,
        "taps": 149,
        "imp_click_rate": "4.76%",
        "cli_price": 15.4,
        "installs": 100,
        "cli_installs_rate": "67.11%",
        "installs_price": 22.95
    },
    {
        "date": "2024/12/01",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 17.24,
        "impressions": 84,
        "ecpm": 205.23,
        "taps": 1,
        "imp_click_rate": "1.19%",
        "cli_price": 17.24,
        "installs": 0,
        "cli_installs_rate": "0.00%",
        "installs_price": 0
    },
    {
        "date": "2024/11/30",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 79705.37,
        "impressions": 52368,
        "ecpm": 1522.02,
        "taps": 27135,
        "imp_click_rate": "51.82%",
        "cli_price": 2.94,
        "installs": 22373,
        "cli_installs_rate": "82.45%",
        "installs_price": 3.56
    },
    {
        "date": "2024/11/30",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1757.83,
        "impressions": 1158,
        "ecpm": 1517.99,
        "taps": 569,
        "imp_click_rate": "49.14%",
        "cli_price": 3.09,
        "installs": 457,
        "cli_installs_rate": "80.32%",
        "installs_price": 3.85
    },
    {
        "date": "2024/11/30",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1096.98,
        "impressions": 625,
        "ecpm": 1755.17,
        "taps": 320,
        "imp_click_rate": "51.20%",
        "cli_price": 3.43,
        "installs": 262,
        "cli_installs_rate": "81.88%",
        "installs_price": 4.19
    },
    {
        "date": "2024/11/30",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 40.21,
        "impressions": 63,
        "ecpm": 638.22,
        "taps": 11,
        "imp_click_rate": "17.46%",
        "cli_price": 3.66,
        "installs": 8,
        "cli_installs_rate": "72.73%",
        "installs_price": 5.03
    },
    {
        "date": "2024/11/30",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 27191.67,
        "impressions": 11761,
        "ecpm": 2312.02,
        "taps": 1789,
        "imp_click_rate": "15.21%",
        "cli_price": 15.2,
        "installs": 1464,
        "cli_installs_rate": "81.83%",
        "installs_price": 18.57
    },
    {
        "date": "2024/11/30",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 530.69,
        "impressions": 3127,
        "ecpm": 169.71,
        "taps": 41,
        "imp_click_rate": "1.31%",
        "cli_price": 12.94,
        "installs": 22,
        "cli_installs_rate": "53.66%",
        "installs_price": 24.12
    },
    {
        "date": "2024/11/30",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 4280.03,
        "impressions": 5106,
        "ecpm": 838.24,
        "taps": 488,
        "imp_click_rate": "9.56%",
        "cli_price": 8.77,
        "installs": 385,
        "cli_installs_rate": "78.89%",
        "installs_price": 11.12
    },
    {
        "date": "2024/11/30",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 54.89,
        "impressions": 1290,
        "ecpm": 42.55,
        "taps": 7,
        "imp_click_rate": "0.54%",
        "cli_price": 7.84,
        "installs": 7,
        "cli_installs_rate": "100.00%",
        "installs_price": 7.84
    },
    {
        "date": "2024/11/30",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 5729.16,
        "impressions": 7882,
        "ecpm": 726.87,
        "taps": 337,
        "imp_click_rate": "4.28%",
        "cli_price": 17,
        "installs": 221,
        "cli_installs_rate": "65.58%",
        "installs_price": 25.92
    },
    {
        "date": "2024/11/30",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 134.43,
        "impressions": 367,
        "ecpm": 366.3,
        "taps": 9,
        "imp_click_rate": "2.45%",
        "cli_price": 14.94,
        "installs": 6,
        "cli_installs_rate": "66.67%",
        "installs_price": 22.41
    },
    {
        "date": "2024/11/30",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 2396.31,
        "impressions": 3058,
        "ecpm": 783.62,
        "taps": 150,
        "imp_click_rate": "4.91%",
        "cli_price": 15.98,
        "installs": 94,
        "cli_installs_rate": "62.67%",
        "installs_price": 25.49
    },
    {
        "date": "2024/11/30",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 86.87,
        "impressions": 112,
        "ecpm": 775.62,
        "taps": 5,
        "imp_click_rate": "4.46%",
        "cli_price": 17.37,
        "installs": 4,
        "cli_installs_rate": "80.00%",
        "installs_price": 21.72
    },
    {
        "date": "2024/11/29",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 75358.32,
        "impressions": 52425,
        "ecpm": 1437.45,
        "taps": 26966,
        "imp_click_rate": "51.44%",
        "cli_price": 2.79,
        "installs": 22163,
        "cli_installs_rate": "82.19%",
        "installs_price": 3.4
    },
    {
        "date": "2024/11/29",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1641.01,
        "impressions": 1206,
        "ecpm": 1360.71,
        "taps": 567,
        "imp_click_rate": "47.01%",
        "cli_price": 2.89,
        "installs": 461,
        "cli_installs_rate": "81.31%",
        "installs_price": 3.56
    },
    {
        "date": "2024/11/29",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1124.17,
        "impressions": 656,
        "ecpm": 1713.67,
        "taps": 327,
        "imp_click_rate": "49.85%",
        "cli_price": 3.44,
        "installs": 286,
        "cli_installs_rate": "87.46%",
        "installs_price": 3.93
    },
    {
        "date": "2024/11/29",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 44.57,
        "impressions": 66,
        "ecpm": 675.37,
        "taps": 11,
        "imp_click_rate": "16.67%",
        "cli_price": 4.05,
        "installs": 8,
        "cli_installs_rate": "72.73%",
        "installs_price": 5.57
    },
    {
        "date": "2024/11/29",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 30931.55,
        "impressions": 11754,
        "ecpm": 2631.58,
        "taps": 1735,
        "imp_click_rate": "14.76%",
        "cli_price": 17.83,
        "installs": 1386,
        "cli_installs_rate": "79.88%",
        "installs_price": 22.32
    },
    {
        "date": "2024/11/29",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 537.24,
        "impressions": 3692,
        "ecpm": 145.51,
        "taps": 47,
        "imp_click_rate": "1.27%",
        "cli_price": 11.43,
        "installs": 27,
        "cli_installs_rate": "57.45%",
        "installs_price": 19.9
    },
    {
        "date": "2024/11/29",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 4113.69,
        "impressions": 4973,
        "ecpm": 827.21,
        "taps": 429,
        "imp_click_rate": "8.63%",
        "cli_price": 9.59,
        "installs": 330,
        "cli_installs_rate": "76.92%",
        "installs_price": 12.47
    },
    {
        "date": "2024/11/29",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 166.86,
        "impressions": 956,
        "ecpm": 174.54,
        "taps": 12,
        "imp_click_rate": "1.26%",
        "cli_price": 13.91,
        "installs": 9,
        "cli_installs_rate": "75.00%",
        "installs_price": 18.54
    },
    {
        "date": "2024/11/29",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 4869.77,
        "impressions": 7552,
        "ecpm": 644.83,
        "taps": 294,
        "imp_click_rate": "3.89%",
        "cli_price": 16.56,
        "installs": 186,
        "cli_installs_rate": "63.27%",
        "installs_price": 26.18
    },
    {
        "date": "2024/11/29",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 39.23,
        "impressions": 357,
        "ecpm": 109.9,
        "taps": 3,
        "imp_click_rate": "0.84%",
        "cli_price": 13.08,
        "installs": 3,
        "cli_installs_rate": "100.00%",
        "installs_price": 13.08
    },
    {
        "date": "2024/11/29",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 3590.82,
        "impressions": 4628,
        "ecpm": 775.89,
        "taps": 219,
        "imp_click_rate": "4.73%",
        "cli_price": 16.4,
        "installs": 147,
        "cli_installs_rate": "67.12%",
        "installs_price": 24.43
    },
    {
        "date": "2024/11/29",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 67.01,
        "impressions": 191,
        "ecpm": 350.82,
        "taps": 5,
        "imp_click_rate": "2.62%",
        "cli_price": 13.4,
        "installs": 3,
        "cli_installs_rate": "60.00%",
        "installs_price": 22.34
    },
    {
        "date": "2024/11/28",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 76483.68,
        "impressions": 57602,
        "ecpm": 1327.8,
        "taps": 29835,
        "imp_click_rate": "51.80%",
        "cli_price": 2.56,
        "installs": 24727,
        "cli_installs_rate": "82.88%",
        "installs_price": 3.09
    },
    {
        "date": "2024/11/28",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1771.42,
        "impressions": 1349,
        "ecpm": 1313.13,
        "taps": 647,
        "imp_click_rate": "47.96%",
        "cli_price": 2.74,
        "installs": 537,
        "cli_installs_rate": "83.00%",
        "installs_price": 3.3
    },
    {
        "date": "2024/11/28",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1107.45,
        "impressions": 649,
        "ecpm": 1706.39,
        "taps": 332,
        "imp_click_rate": "51.16%",
        "cli_price": 3.34,
        "installs": 284,
        "cli_installs_rate": "85.54%",
        "installs_price": 3.9
    },
    {
        "date": "2024/11/28",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 47.46,
        "impressions": 30,
        "ecpm": 1582.08,
        "taps": 13,
        "imp_click_rate": "43.33%",
        "cli_price": 3.65,
        "installs": 10,
        "cli_installs_rate": "76.92%",
        "installs_price": 4.75
    },
    {
        "date": "2024/11/28",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 30956.73,
        "impressions": 12435,
        "ecpm": 2489.48,
        "taps": 1790,
        "imp_click_rate": "14.39%",
        "cli_price": 17.29,
        "installs": 1410,
        "cli_installs_rate": "78.77%",
        "installs_price": 21.96
    },
    {
        "date": "2024/11/28",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 608.73,
        "impressions": 4871,
        "ecpm": 124.97,
        "taps": 52,
        "imp_click_rate": "1.07%",
        "cli_price": 11.71,
        "installs": 22,
        "cli_installs_rate": "42.31%",
        "installs_price": 27.67
    },
    {
        "date": "2024/11/28",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 4011.47,
        "impressions": 4733,
        "ecpm": 847.55,
        "taps": 465,
        "imp_click_rate": "9.82%",
        "cli_price": 8.63,
        "installs": 352,
        "cli_installs_rate": "75.70%",
        "installs_price": 11.4
    },
    {
        "date": "2024/11/28",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 24.7,
        "impressions": 819,
        "ecpm": 30.15,
        "taps": 3,
        "imp_click_rate": "0.37%",
        "cli_price": 8.23,
        "installs": 3,
        "cli_installs_rate": "100.00%",
        "installs_price": 8.23
    },
    {
        "date": "2024/11/28",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 5010.48,
        "impressions": 6918,
        "ecpm": 724.27,
        "taps": 298,
        "imp_click_rate": "4.31%",
        "cli_price": 16.81,
        "installs": 197,
        "cli_installs_rate": "66.11%",
        "installs_price": 25.43
    },
    {
        "date": "2024/11/28",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 124.77,
        "impressions": 326,
        "ecpm": 382.72,
        "taps": 8,
        "imp_click_rate": "2.45%",
        "cli_price": 15.6,
        "installs": 7,
        "cli_installs_rate": "87.50%",
        "installs_price": 17.82
    },
    {
        "date": "2024/11/28",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 2763.4,
        "impressions": 3720,
        "ecpm": 742.85,
        "taps": 168,
        "imp_click_rate": "4.52%",
        "cli_price": 16.45,
        "installs": 106,
        "cli_installs_rate": "63.10%",
        "installs_price": 26.07
    },
    {
        "date": "2024/11/28",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 7.7,
        "impressions": 108,
        "ecpm": 71.29,
        "taps": 1,
        "imp_click_rate": "0.93%",
        "cli_price": 7.7,
        "installs": 0,
        "cli_installs_rate": "0.00%",
        "installs_price": 0
    },
    {
        "date": "2024/11/27",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 71229.36,
        "impressions": 59261,
        "ecpm": 1201.96,
        "taps": 30892,
        "imp_click_rate": "52.13%",
        "cli_price": 2.31,
        "installs": 25488,
        "cli_installs_rate": "82.51%",
        "installs_price": 2.79
    },
    {
        "date": "2024/11/27",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1750.85,
        "impressions": 1444,
        "ecpm": 1212.5,
        "taps": 682,
        "imp_click_rate": "47.23%",
        "cli_price": 2.57,
        "installs": 568,
        "cli_installs_rate": "83.28%",
        "installs_price": 3.08
    },
    {
        "date": "2024/11/27",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1312.75,
        "impressions": 716,
        "ecpm": 1833.45,
        "taps": 377,
        "imp_click_rate": "52.65%",
        "cli_price": 3.48,
        "installs": 314,
        "cli_installs_rate": "83.29%",
        "installs_price": 4.18
    },
    {
        "date": "2024/11/27",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 22.99,
        "impressions": 60,
        "ecpm": 383.2,
        "taps": 7,
        "imp_click_rate": "11.67%",
        "cli_price": 3.28,
        "installs": 7,
        "cli_installs_rate": "100.00%",
        "installs_price": 3.28
    },
    {
        "date": "2024/11/27",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 32543.84,
        "impressions": 12808,
        "ecpm": 2540.9,
        "taps": 1772,
        "imp_click_rate": "13.84%",
        "cli_price": 18.37,
        "installs": 1438,
        "cli_installs_rate": "81.15%",
        "installs_price": 22.63
    },
    {
        "date": "2024/11/27",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 823.94,
        "impressions": 14422,
        "ecpm": 57.13,
        "taps": 39,
        "imp_click_rate": "0.27%",
        "cli_price": 21.13,
        "installs": 26,
        "cli_installs_rate": "66.67%",
        "installs_price": 31.69
    },
    {
        "date": "2024/11/27",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 3726.72,
        "impressions": 4817,
        "ecpm": 773.66,
        "taps": 415,
        "imp_click_rate": "8.62%",
        "cli_price": 8.98,
        "installs": 316,
        "cli_installs_rate": "76.14%",
        "installs_price": 11.79
    },
    {
        "date": "2024/11/27",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 79.43,
        "impressions": 986,
        "ecpm": 80.56,
        "taps": 7,
        "imp_click_rate": "0.71%",
        "cli_price": 11.35,
        "installs": 5,
        "cli_installs_rate": "71.43%",
        "installs_price": 15.89
    },
    {
        "date": "2024/11/27",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 7370.45,
        "impressions": 9409,
        "ecpm": 783.34,
        "taps": 433,
        "imp_click_rate": "4.60%",
        "cli_price": 17.02,
        "installs": 274,
        "cli_installs_rate": "63.28%",
        "installs_price": 26.9
    },
    {
        "date": "2024/11/27",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 110.21,
        "impressions": 396,
        "ecpm": 278.32,
        "taps": 7,
        "imp_click_rate": "1.77%",
        "cli_price": 15.74,
        "installs": 5,
        "cli_installs_rate": "71.43%",
        "installs_price": 22.04
    },
    {
        "date": "2024/11/27",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 902.32,
        "impressions": 1378,
        "ecpm": 654.81,
        "taps": 59,
        "imp_click_rate": "4.28%",
        "cli_price": 15.29,
        "installs": 36,
        "cli_installs_rate": "61.02%",
        "installs_price": 25.06
    },
    {
        "date": "2024/11/27",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 0,
        "impressions": 97,
        "ecpm": 0,
        "taps": 0,
        "imp_click_rate": "0.00%",
        "cli_price": 0,
        "installs": 0,
        "cli_installs_rate": "0.00%",
        "installs_price": 0
    },
    {
        "date": "2024/11/26",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 71268.32,
        "impressions": 60325,
        "ecpm": 1181.41,
        "taps": 31524,
        "imp_click_rate": "52.26%",
        "cli_price": 2.26,
        "installs": 26018,
        "cli_installs_rate": "82.53%",
        "installs_price": 2.74
    },
    {
        "date": "2024/11/26",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1581.72,
        "impressions": 1354,
        "ecpm": 1168.18,
        "taps": 655,
        "imp_click_rate": "48.38%",
        "cli_price": 2.41,
        "installs": 513,
        "cli_installs_rate": "78.32%",
        "installs_price": 3.08
    },
    {
        "date": "2024/11/26",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1336.37,
        "impressions": 746,
        "ecpm": 1791.38,
        "taps": 420,
        "imp_click_rate": "56.30%",
        "cli_price": 3.18,
        "installs": 362,
        "cli_installs_rate": "86.19%",
        "installs_price": 3.69
    },
    {
        "date": "2024/11/26",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 60.22,
        "impressions": 26,
        "ecpm": 2316.33,
        "taps": 16,
        "imp_click_rate": "61.54%",
        "cli_price": 3.76,
        "installs": 10,
        "cli_installs_rate": "62.50%",
        "installs_price": 6.02
    },
    {
        "date": "2024/11/26",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 30652.32,
        "impressions": 13328,
        "ecpm": 2299.84,
        "taps": 1926,
        "imp_click_rate": "14.45%",
        "cli_price": 15.92,
        "installs": 1584,
        "cli_installs_rate": "82.24%",
        "installs_price": 19.35
    },
    {
        "date": "2024/11/26",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 529.12,
        "impressions": 5097,
        "ecpm": 103.81,
        "taps": 37,
        "imp_click_rate": "0.73%",
        "cli_price": 14.3,
        "installs": 30,
        "cli_installs_rate": "81.08%",
        "installs_price": 17.64
    },
    {
        "date": "2024/11/26",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 4190.81,
        "impressions": 5807,
        "ecpm": 721.68,
        "taps": 480,
        "imp_click_rate": "8.27%",
        "cli_price": 8.73,
        "installs": 361,
        "cli_installs_rate": "75.21%",
        "installs_price": 11.61
    },
    {
        "date": "2024/11/26",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 99.43,
        "impressions": 857,
        "ecpm": 116.02,
        "taps": 10,
        "imp_click_rate": "1.17%",
        "cli_price": 9.94,
        "installs": 6,
        "cli_installs_rate": "60.00%",
        "installs_price": 16.57
    },
    {
        "date": "2024/11/26",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 6397.47,
        "impressions": 8512,
        "ecpm": 751.58,
        "taps": 378,
        "imp_click_rate": "4.44%",
        "cli_price": 16.92,
        "installs": 247,
        "cli_installs_rate": "65.34%",
        "installs_price": 25.9
    },
    {
        "date": "2024/11/26",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 93.55,
        "impressions": 460,
        "ecpm": 203.38,
        "taps": 6,
        "imp_click_rate": "1.30%",
        "cli_price": 15.59,
        "installs": 4,
        "cli_installs_rate": "66.67%",
        "installs_price": 23.39
    },
    {
        "date": "2024/11/26",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1424.06,
        "impressions": 1745,
        "ecpm": 816.08,
        "taps": 90,
        "imp_click_rate": "5.16%",
        "cli_price": 15.82,
        "installs": 56,
        "cli_installs_rate": "62.22%",
        "installs_price": 25.43
    },
    {
        "date": "2024/11/26",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 31.93,
        "impressions": 88,
        "ecpm": 362.83,
        "taps": 2,
        "imp_click_rate": "2.27%",
        "cli_price": 15.96,
        "installs": 1,
        "cli_installs_rate": "50.00%",
        "installs_price": 31.93
    },
    {
        "date": "2024/11/25",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 68576.3,
        "impressions": 58892,
        "ecpm": 1164.44,
        "taps": 30427,
        "imp_click_rate": "51.67%",
        "cli_price": 2.25,
        "installs": 25021,
        "cli_installs_rate": "82.23%",
        "installs_price": 2.74
    },
    {
        "date": "2024/11/25",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1540.98,
        "impressions": 1990,
        "ecpm": 774.36,
        "taps": 636,
        "imp_click_rate": "31.96%",
        "cli_price": 2.42,
        "installs": 521,
        "cli_installs_rate": "81.92%",
        "installs_price": 2.96
    },
    {
        "date": "2024/11/25",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1170.54,
        "impressions": 656,
        "ecpm": 1784.35,
        "taps": 353,
        "imp_click_rate": "53.81%",
        "cli_price": 3.32,
        "installs": 292,
        "cli_installs_rate": "82.72%",
        "installs_price": 4.01
    },
    {
        "date": "2024/11/25",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 54.19,
        "impressions": 50,
        "ecpm": 1083.81,
        "taps": 16,
        "imp_click_rate": "32.00%",
        "cli_price": 3.39,
        "installs": 15,
        "cli_installs_rate": "93.75%",
        "installs_price": 3.61
    },
    {
        "date": "2024/11/25",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 30135.53,
        "impressions": 15191,
        "ecpm": 1983.78,
        "taps": 2061,
        "imp_click_rate": "13.57%",
        "cli_price": 14.62,
        "installs": 1694,
        "cli_installs_rate": "82.19%",
        "installs_price": 17.79
    },
    {
        "date": "2024/11/25",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 593.65,
        "impressions": 9412,
        "ecpm": 63.07,
        "taps": 42,
        "imp_click_rate": "0.45%",
        "cli_price": 14.13,
        "installs": 31,
        "cli_installs_rate": "73.81%",
        "installs_price": 19.15
    },
    {
        "date": "2024/11/25",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 4276.07,
        "impressions": 5294,
        "ecpm": 807.72,
        "taps": 479,
        "imp_click_rate": "9.05%",
        "cli_price": 8.93,
        "installs": 392,
        "cli_installs_rate": "81.84%",
        "installs_price": 10.91
    },
    {
        "date": "2024/11/25",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 63.74,
        "impressions": 1134,
        "ecpm": 56.21,
        "taps": 11,
        "imp_click_rate": "0.97%",
        "cli_price": 5.79,
        "installs": 5,
        "cli_installs_rate": "45.45%",
        "installs_price": 12.75
    },
    {
        "date": "2024/11/25",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 5944.35,
        "impressions": 7848,
        "ecpm": 757.44,
        "taps": 358,
        "imp_click_rate": "4.56%",
        "cli_price": 16.6,
        "installs": 226,
        "cli_installs_rate": "63.13%",
        "installs_price": 26.3
    },
    {
        "date": "2024/11/25",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 136.44,
        "impressions": 359,
        "ecpm": 380.05,
        "taps": 8,
        "imp_click_rate": "2.23%",
        "cli_price": 17.05,
        "installs": 2,
        "cli_installs_rate": "25.00%",
        "installs_price": 68.22
    },
    {
        "date": "2024/11/25",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1796.83,
        "impressions": 2403,
        "ecpm": 747.75,
        "taps": 111,
        "imp_click_rate": "4.62%",
        "cli_price": 16.19,
        "installs": 70,
        "cli_installs_rate": "63.06%",
        "installs_price": 25.67
    },
    {
        "date": "2024/11/25",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 0,
        "impressions": 73,
        "ecpm": 0,
        "taps": 0,
        "imp_click_rate": "0.00%",
        "cli_price": 0,
        "installs": 0,
        "cli_installs_rate": "0.00%",
        "installs_price": 0
    },
    {
        "date": "2024/11/24",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 65267.61,
        "impressions": 55714,
        "ecpm": 1171.48,
        "taps": 29011,
        "imp_click_rate": "52.07%",
        "cli_price": 2.25,
        "installs": 23847,
        "cli_installs_rate": "82.20%",
        "installs_price": 2.74
    },
    {
        "date": "2024/11/24",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1487.52,
        "impressions": 1233,
        "ecpm": 1206.43,
        "taps": 593,
        "imp_click_rate": "48.09%",
        "cli_price": 2.51,
        "installs": 477,
        "cli_installs_rate": "80.44%",
        "installs_price": 3.12
    },
    {
        "date": "2024/11/24",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1015.56,
        "impressions": 605,
        "ecpm": 1678.62,
        "taps": 332,
        "imp_click_rate": "54.88%",
        "cli_price": 3.06,
        "installs": 283,
        "cli_installs_rate": "85.24%",
        "installs_price": 3.59
    },
    {
        "date": "2024/11/24",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 53.22,
        "impressions": 34,
        "ecpm": 1565.35,
        "taps": 14,
        "imp_click_rate": "41.18%",
        "cli_price": 3.8,
        "installs": 11,
        "cli_installs_rate": "78.57%",
        "installs_price": 4.84
    },
    {
        "date": "2024/11/24",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 25290,
        "impressions": 12620,
        "ecpm": 2003.96,
        "taps": 1869,
        "imp_click_rate": "14.81%",
        "cli_price": 13.53,
        "installs": 1549,
        "cli_installs_rate": "82.88%",
        "installs_price": 16.33
    },
    {
        "date": "2024/11/24",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 700.01,
        "impressions": 6108,
        "ecpm": 114.6,
        "taps": 50,
        "imp_click_rate": "0.82%",
        "cli_price": 14,
        "installs": 32,
        "cli_installs_rate": "64.00%",
        "installs_price": 21.88
    },
    {
        "date": "2024/11/24",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 4466.31,
        "impressions": 5437,
        "ecpm": 821.47,
        "taps": 477,
        "imp_click_rate": "8.77%",
        "cli_price": 9.36,
        "installs": 367,
        "cli_installs_rate": "76.94%",
        "installs_price": 12.17
    },
    {
        "date": "2024/11/24",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 125.29,
        "impressions": 1322,
        "ecpm": 94.77,
        "taps": 12,
        "imp_click_rate": "0.91%",
        "cli_price": 10.44,
        "installs": 7,
        "cli_installs_rate": "58.33%",
        "installs_price": 17.9
    },
    {
        "date": "2024/11/24",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 6340.97,
        "impressions": 8108,
        "ecpm": 782.06,
        "taps": 384,
        "imp_click_rate": "4.74%",
        "cli_price": 16.51,
        "installs": 242,
        "cli_installs_rate": "63.02%",
        "installs_price": 26.2
    },
    {
        "date": "2024/11/24",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 215.26,
        "impressions": 409,
        "ecpm": 526.3,
        "taps": 13,
        "imp_click_rate": "3.18%",
        "cli_price": 16.56,
        "installs": 7,
        "cli_installs_rate": "53.85%",
        "installs_price": 30.75
    },
    {
        "date": "2024/11/24",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1203.67,
        "impressions": 1541,
        "ecpm": 781.1,
        "taps": 74,
        "imp_click_rate": "4.80%",
        "cli_price": 16.27,
        "installs": 58,
        "cli_installs_rate": "78.38%",
        "installs_price": 20.75
    },
    {
        "date": "2024/11/24",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 0,
        "impressions": 29,
        "ecpm": 0,
        "taps": 0,
        "imp_click_rate": "0.00%",
        "cli_price": 0,
        "installs": 0,
        "cli_installs_rate": "0.00%",
        "installs_price": 0
    },
    {
        "date": "2024/11/23",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 62569.81,
        "impressions": 53577,
        "ecpm": 1167.85,
        "taps": 27940,
        "imp_click_rate": "52.15%",
        "cli_price": 2.24,
        "installs": 23126,
        "cli_installs_rate": "82.77%",
        "installs_price": 2.71
    },
    {
        "date": "2024/11/23",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1602.95,
        "impressions": 1310,
        "ecpm": 1223.63,
        "taps": 657,
        "imp_click_rate": "50.15%",
        "cli_price": 2.44,
        "installs": 537,
        "cli_installs_rate": "81.74%",
        "installs_price": 2.99
    },
    {
        "date": "2024/11/23",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1066.55,
        "impressions": 640,
        "ecpm": 1666.48,
        "taps": 344,
        "imp_click_rate": "53.75%",
        "cli_price": 3.1,
        "installs": 284,
        "cli_installs_rate": "82.56%",
        "installs_price": 3.76
    },
    {
        "date": "2024/11/23",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 29.42,
        "impressions": 65,
        "ecpm": 452.62,
        "taps": 11,
        "imp_click_rate": "16.92%",
        "cli_price": 2.67,
        "installs": 11,
        "cli_installs_rate": "100.00%",
        "installs_price": 2.67
    },
    {
        "date": "2024/11/23",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 28088.38,
        "impressions": 14831,
        "ecpm": 1893.9,
        "taps": 2033,
        "imp_click_rate": "13.71%",
        "cli_price": 13.82,
        "installs": 1602,
        "cli_installs_rate": "78.80%",
        "installs_price": 17.53
    },
    {
        "date": "2024/11/23",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 609.33,
        "impressions": 21328,
        "ecpm": 28.57,
        "taps": 66,
        "imp_click_rate": "0.31%",
        "cli_price": 9.23,
        "installs": 30,
        "cli_installs_rate": "45.45%",
        "installs_price": 20.31
    },
    {
        "date": "2024/11/23",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 4559.21,
        "impressions": 6603,
        "ecpm": 690.47,
        "taps": 479,
        "imp_click_rate": "7.25%",
        "cli_price": 9.52,
        "installs": 354,
        "cli_installs_rate": "73.90%",
        "installs_price": 12.88
    },
    {
        "date": "2024/11/23",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 95,
        "impressions": 4853,
        "ecpm": 19.58,
        "taps": 9,
        "imp_click_rate": "0.19%",
        "cli_price": 10.56,
        "installs": 5,
        "cli_installs_rate": "55.56%",
        "installs_price": 19
    },
    {
        "date": "2024/11/23",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 7183.44,
        "impressions": 10069,
        "ecpm": 713.42,
        "taps": 444,
        "imp_click_rate": "4.41%",
        "cli_price": 16.18,
        "installs": 280,
        "cli_installs_rate": "63.06%",
        "installs_price": 25.66
    },
    {
        "date": "2024/11/23",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 185.31,
        "impressions": 432,
        "ecpm": 428.96,
        "taps": 11,
        "imp_click_rate": "2.55%",
        "cli_price": 16.85,
        "installs": 7,
        "cli_installs_rate": "63.64%",
        "installs_price": 26.47
    },
    {
        "date": "2024/11/23",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 623.78,
        "impressions": 1058,
        "ecpm": 589.59,
        "taps": 43,
        "imp_click_rate": "4.06%",
        "cli_price": 14.51,
        "installs": 24,
        "cli_installs_rate": "55.81%",
        "installs_price": 25.99
    },
    {
        "date": "2024/11/23",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 45.25,
        "impressions": 63,
        "ecpm": 718.32,
        "taps": 4,
        "imp_click_rate": "6.35%",
        "cli_price": 11.31,
        "installs": 0,
        "cli_installs_rate": "0.00%",
        "installs_price": 0
    },
    {
        "date": "2024/11/22",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 62442.05,
        "impressions": 55065,
        "ecpm": 1133.97,
        "taps": 28805,
        "imp_click_rate": "52.31%",
        "cli_price": 2.17,
        "installs": 23752,
        "cli_installs_rate": "82.46%",
        "installs_price": 2.63
    },
    {
        "date": "2024/11/22",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1393.16,
        "impressions": 1184,
        "ecpm": 1176.65,
        "taps": 585,
        "imp_click_rate": "49.41%",
        "cli_price": 2.38,
        "installs": 481,
        "cli_installs_rate": "82.22%",
        "installs_price": 2.9
    },
    {
        "date": "2024/11/22",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1071.56,
        "impressions": 657,
        "ecpm": 1630.99,
        "taps": 326,
        "imp_click_rate": "49.62%",
        "cli_price": 3.29,
        "installs": 271,
        "cli_installs_rate": "83.13%",
        "installs_price": 3.95
    },
    {
        "date": "2024/11/22",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 16.49,
        "impressions": 16,
        "ecpm": 1030.56,
        "taps": 5,
        "imp_click_rate": "31.25%",
        "cli_price": 3.3,
        "installs": 3,
        "cli_installs_rate": "60.00%",
        "installs_price": 5.5
    },
    {
        "date": "2024/11/22",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 29789.39,
        "impressions": 12790,
        "ecpm": 2329.12,
        "taps": 1926,
        "imp_click_rate": "15.06%",
        "cli_price": 15.47,
        "installs": 1583,
        "cli_installs_rate": "82.19%",
        "installs_price": 18.82
    },
    {
        "date": "2024/11/22",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 509.36,
        "impressions": 2004,
        "ecpm": 254.17,
        "taps": 33,
        "imp_click_rate": "1.65%",
        "cli_price": 15.44,
        "installs": 24,
        "cli_installs_rate": "72.73%",
        "installs_price": 21.22
    },
    {
        "date": "2024/11/22",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 5125.63,
        "impressions": 6329,
        "ecpm": 809.86,
        "taps": 498,
        "imp_click_rate": "7.87%",
        "cli_price": 10.29,
        "installs": 396,
        "cli_installs_rate": "79.52%",
        "installs_price": 12.94
    },
    {
        "date": "2024/11/22",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 232.76,
        "impressions": 1415,
        "ecpm": 164.49,
        "taps": 17,
        "imp_click_rate": "1.20%",
        "cli_price": 13.69,
        "installs": 12,
        "cli_installs_rate": "70.59%",
        "installs_price": 19.4
    },
    {
        "date": "2024/11/22",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 6863.44,
        "impressions": 10255,
        "ecpm": 669.28,
        "taps": 441,
        "imp_click_rate": "4.30%",
        "cli_price": 15.56,
        "installs": 281,
        "cli_installs_rate": "63.72%",
        "installs_price": 24.43
    },
    {
        "date": "2024/11/22",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 178.42,
        "impressions": 381,
        "ecpm": 468.29,
        "taps": 12,
        "imp_click_rate": "3.15%",
        "cli_price": 14.87,
        "installs": 7,
        "cli_installs_rate": "58.33%",
        "installs_price": 25.49
    },
    {
        "date": "2024/11/22",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 2672.19,
        "impressions": 3694,
        "ecpm": 723.39,
        "taps": 170,
        "imp_click_rate": "4.60%",
        "cli_price": 15.72,
        "installs": 116,
        "cli_installs_rate": "68.24%",
        "installs_price": 23.04
    },
    {
        "date": "2024/11/22",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 88.16,
        "impressions": 151,
        "ecpm": 583.84,
        "taps": 6,
        "imp_click_rate": "3.97%",
        "cli_price": 14.69,
        "installs": 4,
        "cli_installs_rate": "66.67%",
        "installs_price": 22.04
    },
    {
        "date": "2024/11/21",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 30228.25,
        "impressions": 13155,
        "ecpm": 2297.85,
        "taps": 1763,
        "imp_click_rate": "13.40%",
        "cli_price": 17.15,
        "installs": 1455,
        "cli_installs_rate": "82.53%",
        "installs_price": 20.78
    },
    {
        "date": "2024/11/21",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 730.66,
        "impressions": 11573,
        "ecpm": 63.13,
        "taps": 41,
        "imp_click_rate": "0.35%",
        "cli_price": 17.82,
        "installs": 29,
        "cli_installs_rate": "70.73%",
        "installs_price": 25.2
    },
    {
        "date": "2024/11/21",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 4837.31,
        "impressions": 5571,
        "ecpm": 868.3,
        "taps": 474,
        "imp_click_rate": "8.51%",
        "cli_price": 10.21,
        "installs": 367,
        "cli_installs_rate": "77.43%",
        "installs_price": 13.18
    },
    {
        "date": "2024/11/21",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 215.72,
        "impressions": 2152,
        "ecpm": 100.24,
        "taps": 19,
        "imp_click_rate": "0.88%",
        "cli_price": 11.35,
        "installs": 13,
        "cli_installs_rate": "68.42%",
        "installs_price": 16.59
    },
    {
        "date": "2024/11/21",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 48277.51,
        "impressions": 46393,
        "ecpm": 1040.62,
        "taps": 24201,
        "imp_click_rate": "52.17%",
        "cli_price": 1.99,
        "installs": 20019,
        "cli_installs_rate": "82.72%",
        "installs_price": 2.41
    },
    {
        "date": "2024/11/21",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1164.81,
        "impressions": 1140,
        "ecpm": 1021.76,
        "taps": 546,
        "imp_click_rate": "47.89%",
        "cli_price": 2.13,
        "installs": 435,
        "cli_installs_rate": "79.67%",
        "installs_price": 2.68
    },
    {
        "date": "2024/11/21",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 915.27,
        "impressions": 554,
        "ecpm": 1652.11,
        "taps": 302,
        "imp_click_rate": "54.51%",
        "cli_price": 3.03,
        "installs": 253,
        "cli_installs_rate": "83.77%",
        "installs_price": 3.62
    },
    {
        "date": "2024/11/21",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 37.68,
        "impressions": 76,
        "ecpm": 495.79,
        "taps": 12,
        "imp_click_rate": "15.79%",
        "cli_price": 3.14,
        "installs": 12,
        "cli_installs_rate": "100.00%",
        "installs_price": 3.14
    },
    {
        "date": "2024/11/21",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 2987.53,
        "impressions": 5707,
        "ecpm": 523.49,
        "taps": 206,
        "imp_click_rate": "3.61%",
        "cli_price": 14.5,
        "installs": 133,
        "cli_installs_rate": "64.56%",
        "installs_price": 22.46
    },
    {
        "date": "2024/11/21",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 90.32,
        "impressions": 390,
        "ecpm": 231.58,
        "taps": 6,
        "imp_click_rate": "1.54%",
        "cli_price": 15.05,
        "installs": 4,
        "cli_installs_rate": "66.67%",
        "installs_price": 22.58
    },
    {
        "date": "2024/11/21",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1984.51,
        "impressions": 2822,
        "ecpm": 703.23,
        "taps": 127,
        "imp_click_rate": "4.50%",
        "cli_price": 15.63,
        "installs": 81,
        "cli_installs_rate": "63.78%",
        "installs_price": 24.5
    },
    {
        "date": "2024/11/21",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 85.72,
        "impressions": 110,
        "ecpm": 779.25,
        "taps": 5,
        "imp_click_rate": "4.55%",
        "cli_price": 17.14,
        "installs": 5,
        "cli_installs_rate": "100.00%",
        "installs_price": 17.14
    },
    {
        "date": "2024/11/20",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 29312.5,
        "impressions": 13129,
        "ecpm": 2232.65,
        "taps": 1733,
        "imp_click_rate": "13.20%",
        "cli_price": 16.91,
        "installs": 1412,
        "cli_installs_rate": "81.48%",
        "installs_price": 20.76
    },
    {
        "date": "2024/11/20",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 434.45,
        "impressions": 16014,
        "ecpm": 27.13,
        "taps": 25,
        "imp_click_rate": "0.16%",
        "cli_price": 17.38,
        "installs": 19,
        "cli_installs_rate": "76.00%",
        "installs_price": 22.87
    },
    {
        "date": "2024/11/20",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 5077.17,
        "impressions": 5430,
        "ecpm": 935.02,
        "taps": 495,
        "imp_click_rate": "9.12%",
        "cli_price": 10.26,
        "installs": 386,
        "cli_installs_rate": "77.98%",
        "installs_price": 13.15
    },
    {
        "date": "2024/11/20",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 127.87,
        "impressions": 1823,
        "ecpm": 70.14,
        "taps": 13,
        "imp_click_rate": "0.71%",
        "cli_price": 9.84,
        "installs": 11,
        "cli_installs_rate": "84.62%",
        "installs_price": 11.62
    },
    {
        "date": "2024/11/20",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 36838.45,
        "impressions": 35422,
        "ecpm": 1039.99,
        "taps": 18483,
        "imp_click_rate": "52.18%",
        "cli_price": 1.99,
        "installs": 15250,
        "cli_installs_rate": "82.51%",
        "installs_price": 2.42
    },
    {
        "date": "2024/11/20",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 803.04,
        "impressions": 972,
        "ecpm": 826.17,
        "taps": 372,
        "imp_click_rate": "38.27%",
        "cli_price": 2.16,
        "installs": 308,
        "cli_installs_rate": "82.80%",
        "installs_price": 2.61
    },
    {
        "date": "2024/11/20",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 621.68,
        "impressions": 408,
        "ecpm": 1523.73,
        "taps": 198,
        "imp_click_rate": "48.53%",
        "cli_price": 3.14,
        "installs": 168,
        "cli_installs_rate": "84.85%",
        "installs_price": 3.7
    },
    {
        "date": "2024/11/20",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 35.51,
        "impressions": 47,
        "ecpm": 755.43,
        "taps": 11,
        "imp_click_rate": "23.40%",
        "cli_price": 3.23,
        "installs": 10,
        "cli_installs_rate": "90.91%",
        "installs_price": 3.55
    },
    {
        "date": "2024/11/20",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 7914.68,
        "impressions": 10287,
        "ecpm": 769.39,
        "taps": 478,
        "imp_click_rate": "4.65%",
        "cli_price": 16.56,
        "installs": 305,
        "cli_installs_rate": "63.81%",
        "installs_price": 25.95
    },
    {
        "date": "2024/11/20",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 165.48,
        "impressions": 390,
        "ecpm": 424.3,
        "taps": 10,
        "imp_click_rate": "2.56%",
        "cli_price": 16.55,
        "installs": 6,
        "cli_installs_rate": "60.00%",
        "installs_price": 27.58
    },
    {
        "date": "2024/11/20",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 386.18,
        "impressions": 621,
        "ecpm": 621.87,
        "taps": 25,
        "imp_click_rate": "4.03%",
        "cli_price": 15.45,
        "installs": 17,
        "cli_installs_rate": "68.00%",
        "installs_price": 22.72
    },
    {
        "date": "2024/11/20",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 15.66,
        "impressions": 30,
        "ecpm": 521.88,
        "taps": 1,
        "imp_click_rate": "3.33%",
        "cli_price": 15.66,
        "installs": 2,
        "cli_installs_rate": "200.00%",
        "installs_price": 7.83
    },
    {
        "date": "2024/11/19",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 27212.21,
        "impressions": 11908,
        "ecpm": 2285.2,
        "taps": 1712,
        "imp_click_rate": "14.38%",
        "cli_price": 15.89,
        "installs": 1416,
        "cli_installs_rate": "82.71%",
        "installs_price": 19.22
    },
    {
        "date": "2024/11/19",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 550.04,
        "impressions": 7312,
        "ecpm": 75.22,
        "taps": 34,
        "imp_click_rate": "0.46%",
        "cli_price": 16.18,
        "installs": 30,
        "cli_installs_rate": "88.24%",
        "installs_price": 18.33
    },
    {
        "date": "2024/11/19",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 5304.38,
        "impressions": 5379,
        "ecpm": 986.13,
        "taps": 526,
        "imp_click_rate": "9.78%",
        "cli_price": 10.08,
        "installs": 417,
        "cli_installs_rate": "79.28%",
        "installs_price": 12.72
    },
    {
        "date": "2024/11/19",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 76.33,
        "impressions": 817,
        "ecpm": 93.43,
        "taps": 7,
        "imp_click_rate": "0.86%",
        "cli_price": 10.9,
        "installs": 7,
        "cli_installs_rate": "100.00%",
        "installs_price": 10.9
    },
    {
        "date": "2024/11/19",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 36711.17,
        "impressions": 35774,
        "ecpm": 1026.2,
        "taps": 18553,
        "imp_click_rate": "51.86%",
        "cli_price": 1.98,
        "installs": 15322,
        "cli_installs_rate": "82.59%",
        "installs_price": 2.4
    },
    {
        "date": "2024/11/19",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 886.79,
        "impressions": 1257,
        "ecpm": 705.48,
        "taps": 414,
        "imp_click_rate": "32.94%",
        "cli_price": 2.14,
        "installs": 338,
        "cli_installs_rate": "81.64%",
        "installs_price": 2.62
    },
    {
        "date": "2024/11/19",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 710.38,
        "impressions": 404,
        "ecpm": 1758.37,
        "taps": 225,
        "imp_click_rate": "55.69%",
        "cli_price": 3.16,
        "installs": 193,
        "cli_installs_rate": "85.78%",
        "installs_price": 3.68
    },
    {
        "date": "2024/11/19",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 29.21,
        "impressions": 16,
        "ecpm": 1825.73,
        "taps": 9,
        "imp_click_rate": "56.25%",
        "cli_price": 3.25,
        "installs": 9,
        "cli_installs_rate": "100.00%",
        "installs_price": 3.25
    },
    {
        "date": "2024/11/19",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 10062.24,
        "impressions": 16732,
        "ecpm": 601.38,
        "taps": 623,
        "imp_click_rate": "3.72%",
        "cli_price": 16.15,
        "installs": 369,
        "cli_installs_rate": "59.23%",
        "installs_price": 27.27
    },
    {
        "date": "2024/11/19",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 339.68,
        "impressions": 601,
        "ecpm": 565.19,
        "taps": 23,
        "imp_click_rate": "3.83%",
        "cli_price": 14.77,
        "installs": 17,
        "cli_installs_rate": "73.91%",
        "installs_price": 19.98
    },
    {
        "date": "2024/11/19",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 883.81,
        "impressions": 1122,
        "ecpm": 787.71,
        "taps": 54,
        "imp_click_rate": "4.81%",
        "cli_price": 16.37,
        "installs": 38,
        "cli_installs_rate": "70.37%",
        "installs_price": 23.26
    },
    {
        "date": "2024/11/19",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 39.57,
        "impressions": 69,
        "ecpm": 573.49,
        "taps": 2,
        "imp_click_rate": "2.90%",
        "cli_price": 19.79,
        "installs": 1,
        "cli_installs_rate": "50.00%",
        "installs_price": 39.57
    },
    {
        "date": "2024/11/18",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 26131.01,
        "impressions": 13451,
        "ecpm": 1942.68,
        "taps": 1961,
        "imp_click_rate": "14.58%",
        "cli_price": 13.33,
        "installs": 1571,
        "cli_installs_rate": "80.11%",
        "installs_price": 16.63
    },
    {
        "date": "2024/11/18",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 668.78,
        "impressions": 6968,
        "ecpm": 95.98,
        "taps": 80,
        "imp_click_rate": "1.15%",
        "cli_price": 8.36,
        "installs": 38,
        "cli_installs_rate": "47.50%",
        "installs_price": 17.6
    },
    {
        "date": "2024/11/18",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 5155.76,
        "impressions": 5566,
        "ecpm": 926.29,
        "taps": 546,
        "imp_click_rate": "9.81%",
        "cli_price": 9.44,
        "installs": 423,
        "cli_installs_rate": "77.47%",
        "installs_price": 12.19
    },
    {
        "date": "2024/11/18",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 54.41,
        "impressions": 2441,
        "ecpm": 22.29,
        "taps": 4,
        "imp_click_rate": "0.16%",
        "cli_price": 13.6,
        "installs": 3,
        "cli_installs_rate": "75.00%",
        "installs_price": 18.14
    },
    {
        "date": "2024/11/18",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 36391.94,
        "impressions": 34089,
        "ecpm": 1067.56,
        "taps": 17874,
        "imp_click_rate": "52.43%",
        "cli_price": 2.04,
        "installs": 14746,
        "cli_installs_rate": "82.50%",
        "installs_price": 2.47
    },
    {
        "date": "2024/11/18",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 956.16,
        "impressions": 1608,
        "ecpm": 594.63,
        "taps": 442,
        "imp_click_rate": "27.49%",
        "cli_price": 2.16,
        "installs": 356,
        "cli_installs_rate": "80.54%",
        "installs_price": 2.69
    },
    {
        "date": "2024/11/18",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 777.5,
        "impressions": 443,
        "ecpm": 1755.07,
        "taps": 257,
        "imp_click_rate": "58.01%",
        "cli_price": 3.03,
        "installs": 221,
        "cli_installs_rate": "85.99%",
        "installs_price": 3.52
    },
    {
        "date": "2024/11/18",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 37.25,
        "impressions": 30,
        "ecpm": 1241.53,
        "taps": 12,
        "imp_click_rate": "40.00%",
        "cli_price": 3.1,
        "installs": 10,
        "cli_installs_rate": "83.33%",
        "installs_price": 3.72
    },
    {
        "date": "2024/11/18",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 4125.67,
        "impressions": 9085,
        "ecpm": 454.12,
        "taps": 310,
        "imp_click_rate": "3.41%",
        "cli_price": 13.31,
        "installs": 186,
        "cli_installs_rate": "60.00%",
        "installs_price": 22.18
    },
    {
        "date": "2024/11/18",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 161.16,
        "impressions": 488,
        "ecpm": 330.26,
        "taps": 11,
        "imp_click_rate": "2.25%",
        "cli_price": 14.65,
        "installs": 8,
        "cli_installs_rate": "72.73%",
        "installs_price": 20.15
    },
    {
        "date": "2024/11/18",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 913.84,
        "impressions": 1130,
        "ecpm": 808.7,
        "taps": 57,
        "imp_click_rate": "5.04%",
        "cli_price": 16.03,
        "installs": 41,
        "cli_installs_rate": "71.93%",
        "installs_price": 22.29
    },
    {
        "date": "2024/11/18",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 19.47,
        "impressions": 64,
        "ecpm": 304.27,
        "taps": 2,
        "imp_click_rate": "3.13%",
        "cli_price": 9.74,
        "installs": 1,
        "cli_installs_rate": "50.00%",
        "installs_price": 19.47
    },
    {
        "date": "2024/11/17",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 19991.05,
        "impressions": 9699,
        "ecpm": 2061.15,
        "taps": 1565,
        "imp_click_rate": "16.14%",
        "cli_price": 12.77,
        "installs": 1301,
        "cli_installs_rate": "83.13%",
        "installs_price": 15.37
    },
    {
        "date": "2024/11/17",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 289.82,
        "impressions": 2848,
        "ecpm": 101.76,
        "taps": 24,
        "imp_click_rate": "0.84%",
        "cli_price": 12.08,
        "installs": 21,
        "cli_installs_rate": "87.50%",
        "installs_price": 13.8
    },
    {
        "date": "2024/11/17",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 7942.4,
        "impressions": 5948,
        "ecpm": 1335.31,
        "taps": 663,
        "imp_click_rate": "11.15%",
        "cli_price": 11.98,
        "installs": 542,
        "cli_installs_rate": "81.75%",
        "installs_price": 14.65
    },
    {
        "date": "2024/11/17",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 188.15,
        "impressions": 1056,
        "ecpm": 178.18,
        "taps": 14,
        "imp_click_rate": "1.33%",
        "cli_price": 13.44,
        "installs": 10,
        "cli_installs_rate": "71.43%",
        "installs_price": 18.82
    },
    {
        "date": "2024/11/17",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 37339.47,
        "impressions": 35890,
        "ecpm": 1040.39,
        "taps": 18562,
        "imp_click_rate": "51.72%",
        "cli_price": 2.01,
        "installs": 15259,
        "cli_installs_rate": "82.21%",
        "installs_price": 2.45
    },
    {
        "date": "2024/11/17",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 824.98,
        "impressions": 1868,
        "ecpm": 441.64,
        "taps": 394,
        "imp_click_rate": "21.09%",
        "cli_price": 2.09,
        "installs": 324,
        "cli_installs_rate": "82.23%",
        "installs_price": 2.55
    },
    {
        "date": "2024/11/17",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 664.94,
        "impressions": 436,
        "ecpm": 1525.09,
        "taps": 223,
        "imp_click_rate": "51.15%",
        "cli_price": 2.98,
        "installs": 192,
        "cli_installs_rate": "86.10%",
        "installs_price": 3.46
    },
    {
        "date": "2024/11/17",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 23.99,
        "impressions": 22,
        "ecpm": 1090.64,
        "taps": 8,
        "imp_click_rate": "36.36%",
        "cli_price": 3,
        "installs": 8,
        "cli_installs_rate": "100.00%",
        "installs_price": 3
    },
    {
        "date": "2024/11/17",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 7517.8,
        "impressions": 13502,
        "ecpm": 556.79,
        "taps": 561,
        "imp_click_rate": "4.15%",
        "cli_price": 13.4,
        "installs": 364,
        "cli_installs_rate": "64.88%",
        "installs_price": 20.65
    },
    {
        "date": "2024/11/17",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 303.9,
        "impressions": 604,
        "ecpm": 503.15,
        "taps": 24,
        "imp_click_rate": "3.97%",
        "cli_price": 12.66,
        "installs": 8,
        "cli_installs_rate": "33.33%",
        "installs_price": 37.99
    },
    {
        "date": "2024/11/17",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 692.07,
        "impressions": 936,
        "ecpm": 739.4,
        "taps": 44,
        "imp_click_rate": "4.70%",
        "cli_price": 15.73,
        "installs": 29,
        "cli_installs_rate": "65.91%",
        "installs_price": 23.86
    },
    {
        "date": "2024/11/17",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 0,
        "impressions": 47,
        "ecpm": 0,
        "taps": 0,
        "imp_click_rate": "0.00%",
        "cli_price": 0,
        "installs": 0,
        "cli_installs_rate": "0.00%",
        "installs_price": 0
    },
    {
        "date": "2024/11/16",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 18068.58,
        "impressions": 9771,
        "ecpm": 1849.2,
        "taps": 1460,
        "imp_click_rate": "14.94%",
        "cli_price": 12.38,
        "installs": 1096,
        "cli_installs_rate": "75.07%",
        "installs_price": 16.49
    },
    {
        "date": "2024/11/16",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 809.48,
        "impressions": 1694,
        "ecpm": 477.85,
        "taps": 79,
        "imp_click_rate": "4.66%",
        "cli_price": 10.25,
        "installs": 30,
        "cli_installs_rate": "37.97%",
        "installs_price": 26.98
    },
    {
        "date": "2024/11/16",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 9223.46,
        "impressions": 6655,
        "ecpm": 1385.94,
        "taps": 778,
        "imp_click_rate": "11.69%",
        "cli_price": 11.86,
        "installs": 610,
        "cli_installs_rate": "78.41%",
        "installs_price": 15.12
    },
    {
        "date": "2024/11/16",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 117.43,
        "impressions": 711,
        "ecpm": 165.16,
        "taps": 15,
        "imp_click_rate": "2.11%",
        "cli_price": 7.83,
        "installs": 10,
        "cli_installs_rate": "66.67%",
        "installs_price": 11.74
    },
    {
        "date": "2024/11/16",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 36546.04,
        "impressions": 34093,
        "ecpm": 1071.95,
        "taps": 17964,
        "imp_click_rate": "52.69%",
        "cli_price": 2.03,
        "installs": 14738,
        "cli_installs_rate": "82.04%",
        "installs_price": 2.48
    },
    {
        "date": "2024/11/16",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 917.99,
        "impressions": 1102,
        "ecpm": 833.02,
        "taps": 416,
        "imp_click_rate": "37.75%",
        "cli_price": 2.21,
        "installs": 343,
        "cli_installs_rate": "82.45%",
        "installs_price": 2.68
    },
    {
        "date": "2024/11/16",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 757.36,
        "impressions": 410,
        "ecpm": 1847.21,
        "taps": 223,
        "imp_click_rate": "54.39%",
        "cli_price": 3.4,
        "installs": 180,
        "cli_installs_rate": "80.72%",
        "installs_price": 4.21
    },
    {
        "date": "2024/11/16",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 23.32,
        "impressions": 15,
        "ecpm": 1554.79,
        "taps": 6,
        "imp_click_rate": "40.00%",
        "cli_price": 3.89,
        "installs": 5,
        "cli_installs_rate": "83.33%",
        "installs_price": 4.66
    },
    {
        "date": "2024/11/16",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 7322.81,
        "impressions": 13794,
        "ecpm": 530.87,
        "taps": 535,
        "imp_click_rate": "3.88%",
        "cli_price": 13.69,
        "installs": 339,
        "cli_installs_rate": "63.36%",
        "installs_price": 21.6
    },
    {
        "date": "2024/11/16",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 265.45,
        "impressions": 562,
        "ecpm": 472.33,
        "taps": 20,
        "imp_click_rate": "3.56%",
        "cli_price": 13.27,
        "installs": 15,
        "cli_installs_rate": "75.00%",
        "installs_price": 17.7
    },
    {
        "date": "2024/11/16",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 720.62,
        "impressions": 1028,
        "ecpm": 700.99,
        "taps": 45,
        "imp_click_rate": "4.38%",
        "cli_price": 16.01,
        "installs": 26,
        "cli_installs_rate": "57.78%",
        "installs_price": 27.72
    },
    {
        "date": "2024/11/16",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 75.19,
        "impressions": 48,
        "ecpm": 1566.42,
        "taps": 4,
        "imp_click_rate": "8.33%",
        "cli_price": 18.8,
        "installs": 2,
        "cli_installs_rate": "50.00%",
        "installs_price": 37.59
    },
    {
        "date": "2024/11/15",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 19578.34,
        "impressions": 11298,
        "ecpm": 1732.9,
        "taps": 1650,
        "imp_click_rate": "14.60%",
        "cli_price": 11.87,
        "installs": 1263,
        "cli_installs_rate": "76.55%",
        "installs_price": 15.5
    },
    {
        "date": "2024/11/15",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 573.54,
        "impressions": 1837,
        "ecpm": 312.22,
        "taps": 64,
        "imp_click_rate": "3.48%",
        "cli_price": 8.96,
        "installs": 27,
        "cli_installs_rate": "42.19%",
        "installs_price": 21.24
    },
    {
        "date": "2024/11/15",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 9922.93,
        "impressions": 7741,
        "ecpm": 1281.87,
        "taps": 840,
        "imp_click_rate": "10.85%",
        "cli_price": 11.81,
        "installs": 661,
        "cli_installs_rate": "78.69%",
        "installs_price": 15.01
    },
    {
        "date": "2024/11/15",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 177.52,
        "impressions": 1307,
        "ecpm": 135.82,
        "taps": 15,
        "imp_click_rate": "1.15%",
        "cli_price": 11.83,
        "installs": 12,
        "cli_installs_rate": "80.00%",
        "installs_price": 14.79
    },
    {
        "date": "2024/11/15",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 37636.41,
        "impressions": 35194,
        "ecpm": 1069.4,
        "taps": 18200,
        "imp_click_rate": "51.71%",
        "cli_price": 2.07,
        "installs": 15027,
        "cli_installs_rate": "82.57%",
        "installs_price": 2.5
    },
    {
        "date": "2024/11/15",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 834.87,
        "impressions": 817,
        "ecpm": 1021.87,
        "taps": 385,
        "imp_click_rate": "47.12%",
        "cli_price": 2.17,
        "installs": 312,
        "cli_installs_rate": "81.04%",
        "installs_price": 2.68
    },
    {
        "date": "2024/11/15",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 759.03,
        "impressions": 424,
        "ecpm": 1790.16,
        "taps": 236,
        "imp_click_rate": "55.66%",
        "cli_price": 3.22,
        "installs": 201,
        "cli_installs_rate": "85.17%",
        "installs_price": 3.78
    },
    {
        "date": "2024/11/15",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 24.46,
        "impressions": 16,
        "ecpm": 1528.63,
        "taps": 8,
        "imp_click_rate": "50.00%",
        "cli_price": 3.06,
        "installs": 7,
        "cli_installs_rate": "87.50%",
        "installs_price": 3.49
    },
    {
        "date": "2024/11/15",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 6268.12,
        "impressions": 11617,
        "ecpm": 539.56,
        "taps": 459,
        "imp_click_rate": "3.95%",
        "cli_price": 13.66,
        "installs": 279,
        "cli_installs_rate": "60.78%",
        "installs_price": 22.47
    },
    {
        "date": "2024/11/15",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 82.43,
        "impressions": 419,
        "ecpm": 196.73,
        "taps": 6,
        "imp_click_rate": "1.43%",
        "cli_price": 13.74,
        "installs": 3,
        "cli_installs_rate": "50.00%",
        "installs_price": 27.48
    },
    {
        "date": "2024/11/15",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 540.69,
        "impressions": 900,
        "ecpm": 600.77,
        "taps": 37,
        "imp_click_rate": "4.11%",
        "cli_price": 14.61,
        "installs": 28,
        "cli_installs_rate": "75.68%",
        "installs_price": 19.31
    },
    {
        "date": "2024/11/15",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 37.44,
        "impressions": 50,
        "ecpm": 748.77,
        "taps": 2,
        "imp_click_rate": "4.00%",
        "cli_price": 18.72,
        "installs": 1,
        "cli_installs_rate": "50.00%",
        "installs_price": 37.44
    },
    {
        "date": "2024/11/14",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 20782.72,
        "impressions": 10464,
        "ecpm": 1986.12,
        "taps": 1508,
        "imp_click_rate": "14.41%",
        "cli_price": 13.78,
        "installs": 1225,
        "cli_installs_rate": "81.23%",
        "installs_price": 16.97
    },
    {
        "date": "2024/11/14",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 401.4,
        "impressions": 3101,
        "ecpm": 129.44,
        "taps": 26,
        "imp_click_rate": "0.84%",
        "cli_price": 15.44,
        "installs": 19,
        "cli_installs_rate": "73.08%",
        "installs_price": 21.13
    },
    {
        "date": "2024/11/14",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 9996.56,
        "impressions": 7989,
        "ecpm": 1251.29,
        "taps": 885,
        "imp_click_rate": "11.08%",
        "cli_price": 11.3,
        "installs": 694,
        "cli_installs_rate": "78.42%",
        "installs_price": 14.4
    },
    {
        "date": "2024/11/14",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 297.41,
        "impressions": 1428,
        "ecpm": 208.27,
        "taps": 24,
        "imp_click_rate": "1.68%",
        "cli_price": 12.39,
        "installs": 18,
        "cli_installs_rate": "75.00%",
        "installs_price": 16.52
    },
    {
        "date": "2024/11/14",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 37025.1,
        "impressions": 37043,
        "ecpm": 999.52,
        "taps": 18964,
        "imp_click_rate": "51.19%",
        "cli_price": 1.95,
        "installs": 15657,
        "cli_installs_rate": "82.56%",
        "installs_price": 2.36
    },
    {
        "date": "2024/11/14",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 870.07,
        "impressions": 902,
        "ecpm": 964.6,
        "taps": 415,
        "imp_click_rate": "46.01%",
        "cli_price": 2.1,
        "installs": 342,
        "cli_installs_rate": "82.41%",
        "installs_price": 2.54
    },
    {
        "date": "2024/11/14",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1180.89,
        "impressions": 606,
        "ecpm": 1948.66,
        "taps": 341,
        "imp_click_rate": "56.27%",
        "cli_price": 3.46,
        "installs": 291,
        "cli_installs_rate": "85.34%",
        "installs_price": 4.06
    },
    {
        "date": "2024/11/14",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 62.14,
        "impressions": 29,
        "ecpm": 2142.6,
        "taps": 19,
        "imp_click_rate": "65.52%",
        "cli_price": 3.27,
        "installs": 18,
        "cli_installs_rate": "94.74%",
        "installs_price": 3.45
    },
    {
        "date": "2024/11/14",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 2636.67,
        "impressions": 5382,
        "ecpm": 489.91,
        "taps": 197,
        "imp_click_rate": "3.66%",
        "cli_price": 13.38,
        "installs": 124,
        "cli_installs_rate": "62.94%",
        "installs_price": 21.26
    },
    {
        "date": "2024/11/14",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 83.26,
        "impressions": 245,
        "ecpm": 339.85,
        "taps": 6,
        "imp_click_rate": "2.45%",
        "cli_price": 13.88,
        "installs": 1,
        "cli_installs_rate": "16.67%",
        "installs_price": 83.26
    },
    {
        "date": "2024/11/14",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 2054.37,
        "impressions": 3107,
        "ecpm": 661.21,
        "taps": 131,
        "imp_click_rate": "4.22%",
        "cli_price": 15.68,
        "installs": 77,
        "cli_installs_rate": "58.78%",
        "installs_price": 26.68
    },
    {
        "date": "2024/11/14",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 57.31,
        "impressions": 94,
        "ecpm": 609.71,
        "taps": 4,
        "imp_click_rate": "4.26%",
        "cli_price": 14.33,
        "installs": 3,
        "cli_installs_rate": "75.00%",
        "installs_price": 19.1
    },
    {
        "date": "2024/11/13",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 20814.72,
        "impressions": 9614,
        "ecpm": 2165.04,
        "taps": 1419,
        "imp_click_rate": "14.76%",
        "cli_price": 14.67,
        "installs": 1183,
        "cli_installs_rate": "83.37%",
        "installs_price": 17.59
    },
    {
        "date": "2024/11/13",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 411.12,
        "impressions": 2360,
        "ecpm": 174.2,
        "taps": 22,
        "imp_click_rate": "0.93%",
        "cli_price": 18.69,
        "installs": 18,
        "cli_installs_rate": "81.82%",
        "installs_price": 22.84
    },
    {
        "date": "2024/11/13",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 11430.08,
        "impressions": 8314,
        "ecpm": 1374.8,
        "taps": 908,
        "imp_click_rate": "10.92%",
        "cli_price": 12.59,
        "installs": 726,
        "cli_installs_rate": "79.96%",
        "installs_price": 15.74
    },
    {
        "date": "2024/11/13",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 307.88,
        "impressions": 4065,
        "ecpm": 75.74,
        "taps": 27,
        "imp_click_rate": "0.66%",
        "cli_price": 11.4,
        "installs": 26,
        "cli_installs_rate": "96.30%",
        "installs_price": 11.84
    },
    {
        "date": "2024/11/13",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 36447.19,
        "impressions": 36507,
        "ecpm": 998.36,
        "taps": 18575,
        "imp_click_rate": "50.88%",
        "cli_price": 1.96,
        "installs": 15376,
        "cli_installs_rate": "82.78%",
        "installs_price": 2.37
    },
    {
        "date": "2024/11/13",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 896.05,
        "impressions": 932,
        "ecpm": 961.42,
        "taps": 433,
        "imp_click_rate": "46.46%",
        "cli_price": 2.07,
        "installs": 338,
        "cli_installs_rate": "78.06%",
        "installs_price": 2.65
    },
    {
        "date": "2024/11/13",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 999.37,
        "impressions": 564,
        "ecpm": 1771.93,
        "taps": 298,
        "imp_click_rate": "52.84%",
        "cli_price": 3.35,
        "installs": 245,
        "cli_installs_rate": "82.21%",
        "installs_price": 4.08
    },
    {
        "date": "2024/11/13",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 34.18,
        "impressions": 34,
        "ecpm": 1005.3,
        "taps": 10,
        "imp_click_rate": "29.41%",
        "cli_price": 3.42,
        "installs": 10,
        "cli_installs_rate": "100.00%",
        "installs_price": 3.42
    },
    {
        "date": "2024/11/13",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 7587.96,
        "impressions": 9616,
        "ecpm": 789.1,
        "taps": 471,
        "imp_click_rate": "4.90%",
        "cli_price": 16.11,
        "installs": 305,
        "cli_installs_rate": "64.76%",
        "installs_price": 24.88
    },
    {
        "date": "2024/11/13",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 189.05,
        "impressions": 264,
        "ecpm": 716.08,
        "taps": 12,
        "imp_click_rate": "4.55%",
        "cli_price": 15.75,
        "installs": 7,
        "cli_installs_rate": "58.33%",
        "installs_price": 27.01
    },
    {
        "date": "2024/11/13",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 998.14,
        "impressions": 2721,
        "ecpm": 366.83,
        "taps": 79,
        "imp_click_rate": "2.90%",
        "cli_price": 12.63,
        "installs": 48,
        "cli_installs_rate": "60.76%",
        "installs_price": 20.79
    },
    {
        "date": "2024/11/13",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 32.99,
        "impressions": 108,
        "ecpm": 305.5,
        "taps": 2,
        "imp_click_rate": "1.85%",
        "cli_price": 16.5,
        "installs": 2,
        "cli_installs_rate": "100.00%",
        "installs_price": 16.5
    },
    {
        "date": "2024/11/12",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 21728.8,
        "impressions": 11368,
        "ecpm": 1911.4,
        "taps": 1616,
        "imp_click_rate": "14.22%",
        "cli_price": 13.45,
        "installs": 1332,
        "cli_installs_rate": "82.43%",
        "installs_price": 16.31
    },
    {
        "date": "2024/11/12",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 333.21,
        "impressions": 5142,
        "ecpm": 64.8,
        "taps": 26,
        "imp_click_rate": "0.51%",
        "cli_price": 12.82,
        "installs": 16,
        "cli_installs_rate": "61.54%",
        "installs_price": 20.83
    },
    {
        "date": "2024/11/12",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 10960.84,
        "impressions": 7335,
        "ecpm": 1494.32,
        "taps": 875,
        "imp_click_rate": "11.93%",
        "cli_price": 12.53,
        "installs": 683,
        "cli_installs_rate": "78.06%",
        "installs_price": 16.05
    },
    {
        "date": "2024/11/12",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 343.03,
        "impressions": 1535,
        "ecpm": 223.47,
        "taps": 25,
        "imp_click_rate": "1.63%",
        "cli_price": 13.72,
        "installs": 19,
        "cli_installs_rate": "76.00%",
        "installs_price": 18.05
    },
    {
        "date": "2024/11/12",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 36133.57,
        "impressions": 35267,
        "ecpm": 1024.57,
        "taps": 18155,
        "imp_click_rate": "51.48%",
        "cli_price": 1.99,
        "installs": 14925,
        "cli_installs_rate": "82.21%",
        "installs_price": 2.42
    },
    {
        "date": "2024/11/12",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 786.18,
        "impressions": 836,
        "ecpm": 940.4,
        "taps": 376,
        "imp_click_rate": "44.98%",
        "cli_price": 2.09,
        "installs": 300,
        "cli_installs_rate": "79.79%",
        "installs_price": 2.62
    },
    {
        "date": "2024/11/12",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 979.13,
        "impressions": 554,
        "ecpm": 1767.38,
        "taps": 310,
        "imp_click_rate": "55.96%",
        "cli_price": 3.16,
        "installs": 264,
        "cli_installs_rate": "85.16%",
        "installs_price": 3.71
    },
    {
        "date": "2024/11/12",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 55.07,
        "impressions": 27,
        "ecpm": 2039.69,
        "taps": 15,
        "imp_click_rate": "55.56%",
        "cli_price": 3.67,
        "installs": 12,
        "cli_installs_rate": "80.00%",
        "installs_price": 4.59
    },
    {
        "date": "2024/11/12",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 7608.62,
        "impressions": 9626,
        "ecpm": 790.42,
        "taps": 464,
        "imp_click_rate": "4.82%",
        "cli_price": 16.4,
        "installs": 303,
        "cli_installs_rate": "65.30%",
        "installs_price": 25.11
    },
    {
        "date": "2024/11/12",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 237.32,
        "impressions": 231,
        "ecpm": 1027.36,
        "taps": 14,
        "imp_click_rate": "6.06%",
        "cli_price": 16.95,
        "installs": 8,
        "cli_installs_rate": "57.14%",
        "installs_price": 29.67
    },
    {
        "date": "2024/11/12",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1018.95,
        "impressions": 2729,
        "ecpm": 373.38,
        "taps": 79,
        "imp_click_rate": "2.89%",
        "cli_price": 12.9,
        "installs": 46,
        "cli_installs_rate": "58.23%",
        "installs_price": 22.15
    },
    {
        "date": "2024/11/12",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 69.63,
        "impressions": 326,
        "ecpm": 213.6,
        "taps": 6,
        "imp_click_rate": "1.84%",
        "cli_price": 11.61,
        "installs": 3,
        "cli_installs_rate": "50.00%",
        "installs_price": 23.21
    },
    {
        "date": "2024/11/11",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 21418.51,
        "impressions": 12495,
        "ecpm": 1714.17,
        "taps": 1630,
        "imp_click_rate": "13.05%",
        "cli_price": 13.14,
        "installs": 1353,
        "cli_installs_rate": "83.01%",
        "installs_price": 15.83
    },
    {
        "date": "2024/11/11",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 428.53,
        "impressions": 14984,
        "ecpm": 28.6,
        "taps": 32,
        "imp_click_rate": "0.21%",
        "cli_price": 13.39,
        "installs": 26,
        "cli_installs_rate": "81.25%",
        "installs_price": 16.48
    },
    {
        "date": "2024/11/11",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 10100.19,
        "impressions": 8530,
        "ecpm": 1184.08,
        "taps": 894,
        "imp_click_rate": "10.48%",
        "cli_price": 11.3,
        "installs": 732,
        "cli_installs_rate": "81.88%",
        "installs_price": 13.8
    },
    {
        "date": "2024/11/11",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 215.47,
        "impressions": 12535,
        "ecpm": 17.19,
        "taps": 20,
        "imp_click_rate": "0.16%",
        "cli_price": 10.77,
        "installs": 18,
        "cli_installs_rate": "90.00%",
        "installs_price": 11.97
    },
    {
        "date": "2024/11/11",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 36758.86,
        "impressions": 34580,
        "ecpm": 1063.01,
        "taps": 18036,
        "imp_click_rate": "52.16%",
        "cli_price": 2.04,
        "installs": 14933,
        "cli_installs_rate": "82.80%",
        "installs_price": 2.46
    },
    {
        "date": "2024/11/11",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 831.61,
        "impressions": 1624,
        "ecpm": 512.07,
        "taps": 389,
        "imp_click_rate": "23.95%",
        "cli_price": 2.14,
        "installs": 320,
        "cli_installs_rate": "82.26%",
        "installs_price": 2.6
    },
    {
        "date": "2024/11/11",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 882.53,
        "impressions": 462,
        "ecpm": 1910.24,
        "taps": 250,
        "imp_click_rate": "54.11%",
        "cli_price": 3.53,
        "installs": 209,
        "cli_installs_rate": "83.60%",
        "installs_price": 4.22
    },
    {
        "date": "2024/11/11",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 39.08,
        "impressions": 98,
        "ecpm": 398.74,
        "taps": 13,
        "imp_click_rate": "13.27%",
        "cli_price": 3.01,
        "installs": 10,
        "cli_installs_rate": "76.92%",
        "installs_price": 3.91
    },
    {
        "date": "2024/11/11",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 7299.68,
        "impressions": 9068,
        "ecpm": 804.99,
        "taps": 439,
        "imp_click_rate": "4.84%",
        "cli_price": 16.63,
        "installs": 296,
        "cli_installs_rate": "67.43%",
        "installs_price": 24.66
    },
    {
        "date": "2024/11/11",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 149,
        "impressions": 222,
        "ecpm": 671.16,
        "taps": 9,
        "imp_click_rate": "4.05%",
        "cli_price": 16.56,
        "installs": 5,
        "cli_installs_rate": "55.56%",
        "installs_price": 29.8
    },
    {
        "date": "2024/11/11",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1506.21,
        "impressions": 3211,
        "ecpm": 469.08,
        "taps": 118,
        "imp_click_rate": "3.67%",
        "cli_price": 12.76,
        "installs": 77,
        "cli_installs_rate": "65.25%",
        "installs_price": 19.56
    },
    {
        "date": "2024/11/11",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 38.71,
        "impressions": 266,
        "ecpm": 145.51,
        "taps": 4,
        "imp_click_rate": "1.50%",
        "cli_price": 9.68,
        "installs": 4,
        "cli_installs_rate": "100.00%",
        "installs_price": 9.68
    },
    {
        "date": "2024/11/10",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 23312.57,
        "impressions": 10148,
        "ecpm": 2297.26,
        "taps": 1662,
        "imp_click_rate": "16.38%",
        "cli_price": 14.03,
        "installs": 1326,
        "cli_installs_rate": "79.78%",
        "installs_price": 17.58
    },
    {
        "date": "2024/11/10",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 500.17,
        "impressions": 1545,
        "ecpm": 323.73,
        "taps": 71,
        "imp_click_rate": "4.60%",
        "cli_price": 7.04,
        "installs": 34,
        "cli_installs_rate": "47.89%",
        "installs_price": 14.71
    },
    {
        "date": "2024/11/10",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 9495.07,
        "impressions": 7116,
        "ecpm": 1334.33,
        "taps": 838,
        "imp_click_rate": "11.78%",
        "cli_price": 11.33,
        "installs": 660,
        "cli_installs_rate": "78.76%",
        "installs_price": 14.39
    },
    {
        "date": "2024/11/10",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 179.77,
        "impressions": 1282,
        "ecpm": 140.22,
        "taps": 16,
        "imp_click_rate": "1.25%",
        "cli_price": 11.24,
        "installs": 10,
        "cli_installs_rate": "62.50%",
        "installs_price": 17.98
    },
    {
        "date": "2024/11/10",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 38304.41,
        "impressions": 35856,
        "ecpm": 1068.28,
        "taps": 18917,
        "imp_click_rate": "52.76%",
        "cli_price": 2.02,
        "installs": 15579,
        "cli_installs_rate": "82.35%",
        "installs_price": 2.46
    },
    {
        "date": "2024/11/10",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 676.89,
        "impressions": 1053,
        "ecpm": 642.82,
        "taps": 316,
        "imp_click_rate": "30.01%",
        "cli_price": 2.14,
        "installs": 265,
        "cli_installs_rate": "83.86%",
        "installs_price": 2.55
    },
    {
        "date": "2024/11/10",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 776.43,
        "impressions": 418,
        "ecpm": 1857.5,
        "taps": 218,
        "imp_click_rate": "52.15%",
        "cli_price": 3.56,
        "installs": 188,
        "cli_installs_rate": "86.24%",
        "installs_price": 4.13
    },
    {
        "date": "2024/11/10",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 18.79,
        "impressions": 89,
        "ecpm": 211.1,
        "taps": 4,
        "imp_click_rate": "4.49%",
        "cli_price": 4.7,
        "installs": 4,
        "cli_installs_rate": "100.00%",
        "installs_price": 4.7
    },
    {
        "date": "2024/11/10",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 7819.99,
        "impressions": 10138,
        "ecpm": 771.35,
        "taps": 475,
        "imp_click_rate": "4.69%",
        "cli_price": 16.46,
        "installs": 293,
        "cli_installs_rate": "61.68%",
        "installs_price": 26.69
    },
    {
        "date": "2024/11/10",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 112.66,
        "impressions": 208,
        "ecpm": 541.65,
        "taps": 7,
        "imp_click_rate": "3.37%",
        "cli_price": 16.09,
        "installs": 5,
        "cli_installs_rate": "71.43%",
        "installs_price": 22.53
    },
    {
        "date": "2024/11/10",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1337.9,
        "impressions": 3029,
        "ecpm": 441.7,
        "taps": 100,
        "imp_click_rate": "3.30%",
        "cli_price": 13.38,
        "installs": 57,
        "cli_installs_rate": "57.00%",
        "installs_price": 23.47
    },
    {
        "date": "2024/11/10",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 0,
        "impressions": 265,
        "ecpm": 0,
        "taps": 0,
        "imp_click_rate": "0.00%",
        "cli_price": 0,
        "installs": 0,
        "cli_installs_rate": "0.00%",
        "installs_price": 0
    },
    {
        "date": "2024/11/09",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 26283.26,
        "impressions": 9880,
        "ecpm": 2660.25,
        "taps": 1584,
        "imp_click_rate": "16.03%",
        "cli_price": 16.59,
        "installs": 1297,
        "cli_installs_rate": "81.88%",
        "installs_price": 20.26
    },
    {
        "date": "2024/11/09",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 357.79,
        "impressions": 899,
        "ecpm": 397.99,
        "taps": 24,
        "imp_click_rate": "2.67%",
        "cli_price": 14.91,
        "installs": 17,
        "cli_installs_rate": "70.83%",
        "installs_price": 21.05
    },
    {
        "date": "2024/11/09",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 9876.85,
        "impressions": 7942,
        "ecpm": 1243.62,
        "taps": 903,
        "imp_click_rate": "11.37%",
        "cli_price": 10.94,
        "installs": 746,
        "cli_installs_rate": "82.61%",
        "installs_price": 13.24
    },
    {
        "date": "2024/11/09",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 192.29,
        "impressions": 568,
        "ecpm": 338.55,
        "taps": 14,
        "imp_click_rate": "2.46%",
        "cli_price": 13.74,
        "installs": 12,
        "cli_installs_rate": "85.71%",
        "installs_price": 16.02
    },
    {
        "date": "2024/11/09",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 36526.14,
        "impressions": 34497,
        "ecpm": 1058.82,
        "taps": 18037,
        "imp_click_rate": "52.29%",
        "cli_price": 2.03,
        "installs": 14881,
        "cli_installs_rate": "82.50%",
        "installs_price": 2.45
    },
    {
        "date": "2024/11/09",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 858.27,
        "impressions": 908,
        "ecpm": 945.23,
        "taps": 397,
        "imp_click_rate": "43.72%",
        "cli_price": 2.16,
        "installs": 339,
        "cli_installs_rate": "85.39%",
        "installs_price": 2.53
    },
    {
        "date": "2024/11/09",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 738.91,
        "impressions": 391,
        "ecpm": 1889.8,
        "taps": 212,
        "imp_click_rate": "54.22%",
        "cli_price": 3.49,
        "installs": 174,
        "cli_installs_rate": "82.08%",
        "installs_price": 4.25
    },
    {
        "date": "2024/11/09",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 20.29,
        "impressions": 16,
        "ecpm": 1268.17,
        "taps": 6,
        "imp_click_rate": "37.50%",
        "cli_price": 3.38,
        "installs": 5,
        "cli_installs_rate": "83.33%",
        "installs_price": 4.06
    },
    {
        "date": "2024/11/09",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 7428.23,
        "impressions": 9423,
        "ecpm": 788.31,
        "taps": 449,
        "imp_click_rate": "4.76%",
        "cli_price": 16.54,
        "installs": 313,
        "cli_installs_rate": "69.71%",
        "installs_price": 23.73
    },
    {
        "date": "2024/11/09",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 149.78,
        "impressions": 178,
        "ecpm": 841.44,
        "taps": 10,
        "imp_click_rate": "5.62%",
        "cli_price": 14.98,
        "installs": 6,
        "cli_installs_rate": "60.00%",
        "installs_price": 24.96
    },
    {
        "date": "2024/11/09",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 2229.8,
        "impressions": 4644,
        "ecpm": 480.15,
        "taps": 166,
        "imp_click_rate": "3.57%",
        "cli_price": 13.43,
        "installs": 89,
        "cli_installs_rate": "53.61%",
        "installs_price": 25.05
    },
    {
        "date": "2024/11/09",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 32.58,
        "impressions": 307,
        "ecpm": 106.14,
        "taps": 2,
        "imp_click_rate": "0.65%",
        "cli_price": 16.29,
        "installs": 0,
        "cli_installs_rate": "0.00%",
        "installs_price": 0
    },
    {
        "date": "2024/11/08",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 28175.92,
        "impressions": 11559,
        "ecpm": 2437.57,
        "taps": 1758,
        "imp_click_rate": "15.21%",
        "cli_price": 16.03,
        "installs": 1377,
        "cli_installs_rate": "78.33%",
        "installs_price": 20.46
    },
    {
        "date": "2024/11/08",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 670.45,
        "impressions": 2946,
        "ecpm": 227.58,
        "taps": 69,
        "imp_click_rate": "2.34%",
        "cli_price": 9.72,
        "installs": 28,
        "cli_installs_rate": "40.58%",
        "installs_price": 23.94
    },
    {
        "date": "2024/11/08",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 10292.44,
        "impressions": 8073,
        "ecpm": 1274.92,
        "taps": 933,
        "imp_click_rate": "11.56%",
        "cli_price": 11.03,
        "installs": 758,
        "cli_installs_rate": "81.24%",
        "installs_price": 13.58
    },
    {
        "date": "2024/11/08",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 159.04,
        "impressions": 1439,
        "ecpm": 110.52,
        "taps": 13,
        "imp_click_rate": "0.90%",
        "cli_price": 12.23,
        "installs": 12,
        "cli_installs_rate": "92.31%",
        "installs_price": 13.25
    },
    {
        "date": "2024/11/08",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 36768.33,
        "impressions": 33335,
        "ecpm": 1102.99,
        "taps": 17449,
        "imp_click_rate": "52.34%",
        "cli_price": 2.11,
        "installs": 14460,
        "cli_installs_rate": "82.87%",
        "installs_price": 2.54
    },
    {
        "date": "2024/11/08",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 958.98,
        "impressions": 1126,
        "ecpm": 851.67,
        "taps": 427,
        "imp_click_rate": "37.92%",
        "cli_price": 2.25,
        "installs": 348,
        "cli_installs_rate": "81.50%",
        "installs_price": 2.76
    },
    {
        "date": "2024/11/08",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 693.74,
        "impressions": 406,
        "ecpm": 1708.72,
        "taps": 220,
        "imp_click_rate": "54.19%",
        "cli_price": 3.15,
        "installs": 180,
        "cli_installs_rate": "81.82%",
        "installs_price": 3.85
    },
    {
        "date": "2024/11/08",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 24.99,
        "impressions": 13,
        "ecpm": 1922.55,
        "taps": 8,
        "imp_click_rate": "61.54%",
        "cli_price": 3.12,
        "installs": 7,
        "cli_installs_rate": "87.50%",
        "installs_price": 3.57
    },
    {
        "date": "2024/11/08",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 5626.39,
        "impressions": 9509,
        "ecpm": 591.69,
        "taps": 402,
        "imp_click_rate": "4.23%",
        "cli_price": 14,
        "installs": 235,
        "cli_installs_rate": "58.46%",
        "installs_price": 23.94
    },
    {
        "date": "2024/11/08",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 102.59,
        "impressions": 751,
        "ecpm": 136.6,
        "taps": 7,
        "imp_click_rate": "0.93%",
        "cli_price": 14.66,
        "installs": 2,
        "cli_installs_rate": "28.57%",
        "installs_price": 51.29
    },
    {
        "date": "2024/11/08",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 2311.9,
        "impressions": 4139,
        "ecpm": 558.57,
        "taps": 137,
        "imp_click_rate": "3.31%",
        "cli_price": 16.88,
        "installs": 98,
        "cli_installs_rate": "71.53%",
        "installs_price": 23.59
    },
    {
        "date": "2024/11/08",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 53.59,
        "impressions": 174,
        "ecpm": 308,
        "taps": 3,
        "imp_click_rate": "1.72%",
        "cli_price": 17.86,
        "installs": 4,
        "cli_installs_rate": "133.33%",
        "installs_price": 13.4
    },
    {
        "date": "2024/11/07",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 26589.56,
        "impressions": 11214,
        "ecpm": 2371.1,
        "taps": 1534,
        "imp_click_rate": "13.68%",
        "cli_price": 17.33,
        "installs": 1263,
        "cli_installs_rate": "82.33%",
        "installs_price": 21.05
    },
    {
        "date": "2024/11/07",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 356.85,
        "impressions": 16445,
        "ecpm": 21.7,
        "taps": 25,
        "imp_click_rate": "0.15%",
        "cli_price": 14.27,
        "installs": 22,
        "cli_installs_rate": "88.00%",
        "installs_price": 16.22
    },
    {
        "date": "2024/11/07",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 10329.04,
        "impressions": 7232,
        "ecpm": 1428.24,
        "taps": 867,
        "imp_click_rate": "11.99%",
        "cli_price": 11.91,
        "installs": 695,
        "cli_installs_rate": "80.16%",
        "installs_price": 14.86
    },
    {
        "date": "2024/11/07",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 286.52,
        "impressions": 1715,
        "ecpm": 167.07,
        "taps": 20,
        "imp_click_rate": "1.17%",
        "cli_price": 14.33,
        "installs": 16,
        "cli_installs_rate": "80.00%",
        "installs_price": 17.91
    },
    {
        "date": "2024/11/07",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 37240.63,
        "impressions": 35029,
        "ecpm": 1063.14,
        "taps": 18160,
        "imp_click_rate": "51.84%",
        "cli_price": 2.05,
        "installs": 15006,
        "cli_installs_rate": "82.63%",
        "installs_price": 2.48
    },
    {
        "date": "2024/11/07",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 936.52,
        "impressions": 1200,
        "ecpm": 780.43,
        "taps": 435,
        "imp_click_rate": "36.25%",
        "cli_price": 2.15,
        "installs": 347,
        "cli_installs_rate": "79.77%",
        "installs_price": 2.7
    },
    {
        "date": "2024/11/07",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 722.92,
        "impressions": 389,
        "ecpm": 1858.42,
        "taps": 228,
        "imp_click_rate": "58.61%",
        "cli_price": 3.17,
        "installs": 201,
        "cli_installs_rate": "88.16%",
        "installs_price": 3.6
    },
    {
        "date": "2024/11/07",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 37.37,
        "impressions": 20,
        "ecpm": 1868.57,
        "taps": 13,
        "imp_click_rate": "65.00%",
        "cli_price": 2.87,
        "installs": 8,
        "cli_installs_rate": "61.54%",
        "installs_price": 4.67
    },
    {
        "date": "2024/11/07",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 5325.07,
        "impressions": 7799,
        "ecpm": 682.79,
        "taps": 374,
        "imp_click_rate": "4.80%",
        "cli_price": 14.24,
        "installs": 225,
        "cli_installs_rate": "60.16%",
        "installs_price": 23.67
    },
    {
        "date": "2024/11/07",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 122.65,
        "impressions": 597,
        "ecpm": 205.45,
        "taps": 10,
        "imp_click_rate": "1.68%",
        "cli_price": 12.27,
        "installs": 5,
        "cli_installs_rate": "50.00%",
        "installs_price": 24.53
    },
    {
        "date": "2024/11/07",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 1870.75,
        "impressions": 2602,
        "ecpm": 718.97,
        "taps": 113,
        "imp_click_rate": "4.34%",
        "cli_price": 16.56,
        "installs": 67,
        "cli_installs_rate": "59.29%",
        "installs_price": 27.92
    },
    {
        "date": "2024/11/07",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 65.68,
        "impressions": 121,
        "ecpm": 542.8,
        "taps": 4,
        "imp_click_rate": "3.31%",
        "cli_price": 16.42,
        "installs": 2,
        "cli_installs_rate": "50.00%",
        "installs_price": 32.84
    },
    {
        "date": "2024/11/06",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 28285.21,
        "impressions": 10016,
        "ecpm": 2824,
        "taps": 1596,
        "imp_click_rate": "15.93%",
        "cli_price": 17.72,
        "installs": 1288,
        "cli_installs_rate": "80.70%",
        "installs_price": 21.96
    },
    {
        "date": "2024/11/06",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 252.14,
        "impressions": 1806,
        "ecpm": 139.61,
        "taps": 17,
        "imp_click_rate": "0.94%",
        "cli_price": 14.83,
        "installs": 10,
        "cli_installs_rate": "58.82%",
        "installs_price": 25.21
    },
    {
        "date": "2024/11/06",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 9784.08,
        "impressions": 7591,
        "ecpm": 1288.91,
        "taps": 896,
        "imp_click_rate": "11.80%",
        "cli_price": 10.92,
        "installs": 726,
        "cli_installs_rate": "81.03%",
        "installs_price": 13.48
    },
    {
        "date": "2024/11/06",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 225.65,
        "impressions": 1644,
        "ecpm": 137.26,
        "taps": 24,
        "imp_click_rate": "1.46%",
        "cli_price": 9.4,
        "installs": 14,
        "cli_installs_rate": "58.33%",
        "installs_price": 16.12
    },
    {
        "date": "2024/11/06",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 37177.17,
        "impressions": 36421,
        "ecpm": 1020.76,
        "taps": 19138,
        "imp_click_rate": "52.55%",
        "cli_price": 1.94,
        "installs": 15788,
        "cli_installs_rate": "82.50%",
        "installs_price": 2.35
    },
    {
        "date": "2024/11/06",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 860.26,
        "impressions": 1314,
        "ecpm": 654.69,
        "taps": 422,
        "imp_click_rate": "32.12%",
        "cli_price": 2.04,
        "installs": 329,
        "cli_installs_rate": "77.96%",
        "installs_price": 2.61
    },
    {
        "date": "2024/11/06",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 771.51,
        "impressions": 449,
        "ecpm": 1718.28,
        "taps": 244,
        "imp_click_rate": "54.34%",
        "cli_price": 3.16,
        "installs": 210,
        "cli_installs_rate": "86.07%",
        "installs_price": 3.67
    },
    {
        "date": "2024/11/06",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 24.35,
        "impressions": 18,
        "ecpm": 1352.74,
        "taps": 8,
        "imp_click_rate": "44.44%",
        "cli_price": 3.04,
        "installs": 7,
        "cli_installs_rate": "87.50%",
        "installs_price": 3.48
    },
    {
        "date": "2024/11/06",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 5206.41,
        "impressions": 5676,
        "ecpm": 917.27,
        "taps": 307,
        "imp_click_rate": "5.41%",
        "cli_price": 16.96,
        "installs": 194,
        "cli_installs_rate": "63.19%",
        "installs_price": 26.84
    },
    {
        "date": "2024/11/06",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 81.42,
        "impressions": 179,
        "ecpm": 454.85,
        "taps": 5,
        "imp_click_rate": "2.79%",
        "cli_price": 16.28,
        "installs": 4,
        "cli_installs_rate": "80.00%",
        "installs_price": 20.35
    },
    {
        "date": "2024/11/06",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 3692.11,
        "impressions": 6601,
        "ecpm": 559.33,
        "taps": 245,
        "imp_click_rate": "3.71%",
        "cli_price": 15.07,
        "installs": 156,
        "cli_installs_rate": "63.67%",
        "installs_price": 23.67
    },
    {
        "date": "2024/11/06",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 48.54,
        "impressions": 403,
        "ecpm": 120.45,
        "taps": 3,
        "imp_click_rate": "0.74%",
        "cli_price": 16.18,
        "installs": 2,
        "cli_installs_rate": "66.67%",
        "installs_price": 24.27
    },
    {
        "date": "2024/11/05",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 26785.83,
        "impressions": 9897,
        "ecpm": 2706.46,
        "taps": 1482,
        "imp_click_rate": "14.97%",
        "cli_price": 18.07,
        "installs": 1180,
        "cli_installs_rate": "79.62%",
        "installs_price": 22.7
    },
    {
        "date": "2024/11/05",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 506.83,
        "impressions": 1862,
        "ecpm": 272.2,
        "taps": 30,
        "imp_click_rate": "1.61%",
        "cli_price": 16.89,
        "installs": 23,
        "cli_installs_rate": "76.67%",
        "installs_price": 22.04
    },
    {
        "date": "2024/11/05",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 8984.28,
        "impressions": 7560,
        "ecpm": 1188.4,
        "taps": 845,
        "imp_click_rate": "11.18%",
        "cli_price": 10.63,
        "installs": 679,
        "cli_installs_rate": "80.36%",
        "installs_price": 13.23
    },
    {
        "date": "2024/11/05",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 135.62,
        "impressions": 657,
        "ecpm": 206.42,
        "taps": 10,
        "imp_click_rate": "1.52%",
        "cli_price": 13.56,
        "installs": 5,
        "cli_installs_rate": "50.00%",
        "installs_price": 27.12
    },
    {
        "date": "2024/11/05",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 36779.26,
        "impressions": 37021,
        "ecpm": 993.47,
        "taps": 19404,
        "imp_click_rate": "52.41%",
        "cli_price": 1.9,
        "installs": 16018,
        "cli_installs_rate": "82.55%",
        "installs_price": 2.3
    },
    {
        "date": "2024/11/05",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 889.46,
        "impressions": 993,
        "ecpm": 895.73,
        "taps": 445,
        "imp_click_rate": "44.81%",
        "cli_price": 2,
        "installs": 374,
        "cli_installs_rate": "84.04%",
        "installs_price": 2.38
    },
    {
        "date": "2024/11/05",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 945.03,
        "impressions": 505,
        "ecpm": 1871.35,
        "taps": 288,
        "imp_click_rate": "57.03%",
        "cli_price": 3.28,
        "installs": 243,
        "cli_installs_rate": "84.38%",
        "installs_price": 3.89
    },
    {
        "date": "2024/11/05",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 47.36,
        "impressions": 30,
        "ecpm": 1578.8,
        "taps": 16,
        "imp_click_rate": "53.33%",
        "cli_price": 2.96,
        "installs": 12,
        "cli_installs_rate": "75.00%",
        "installs_price": 3.95
    },
    {
        "date": "2024/11/05",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 6919,
        "impressions": 11644,
        "ecpm": 594.21,
        "taps": 480,
        "imp_click_rate": "4.12%",
        "cli_price": 14.41,
        "installs": 296,
        "cli_installs_rate": "61.67%",
        "installs_price": 23.37
    },
    {
        "date": "2024/11/05",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 216.72,
        "impressions": 409,
        "ecpm": 529.88,
        "taps": 16,
        "imp_click_rate": "3.91%",
        "cli_price": 13.55,
        "installs": 6,
        "cli_installs_rate": "37.50%",
        "installs_price": 36.12
    },
    {
        "date": "2024/11/05",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 253.17,
        "impressions": 424,
        "ecpm": 597.1,
        "taps": 18,
        "imp_click_rate": "4.25%",
        "cli_price": 14.06,
        "installs": 9,
        "cli_installs_rate": "50.00%",
        "installs_price": 28.13
    },
    {
        "date": "2024/11/05",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 0,
        "impressions": 33,
        "ecpm": 0,
        "taps": 0,
        "imp_click_rate": "0.00%",
        "cli_price": 0,
        "installs": 0,
        "cli_installs_rate": "0.00%",
        "installs_price": 0
    },
    {
        "date": "2024/11/04",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 28143.15,
        "impressions": 10926,
        "ecpm": 2575.8,
        "taps": 1505,
        "imp_click_rate": "13.77%",
        "cli_price": 18.7,
        "installs": 1235,
        "cli_installs_rate": "82.06%",
        "installs_price": 22.79
    },
    {
        "date": "2024/11/04",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 279.91,
        "impressions": 6721,
        "ecpm": 41.65,
        "taps": 19,
        "imp_click_rate": "0.28%",
        "cli_price": 14.73,
        "installs": 13,
        "cli_installs_rate": "68.42%",
        "installs_price": 21.53
    },
    {
        "date": "2024/11/04",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 9697.98,
        "impressions": 8212,
        "ecpm": 1180.95,
        "taps": 896,
        "imp_click_rate": "10.91%",
        "cli_price": 10.82,
        "installs": 725,
        "cli_installs_rate": "80.92%",
        "installs_price": 13.38
    },
    {
        "date": "2024/11/04",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 210.07,
        "impressions": 1355,
        "ecpm": 155.03,
        "taps": 17,
        "imp_click_rate": "1.25%",
        "cli_price": 12.36,
        "installs": 12,
        "cli_installs_rate": "70.59%",
        "installs_price": 17.51
    },
    {
        "date": "2024/11/04",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 36689.13,
        "impressions": 37109,
        "ecpm": 988.69,
        "taps": 19535,
        "imp_click_rate": "52.64%",
        "cli_price": 1.88,
        "installs": 16091,
        "cli_installs_rate": "82.37%",
        "installs_price": 2.28
    },
    {
        "date": "2024/11/04",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 902.48,
        "impressions": 1003,
        "ecpm": 899.78,
        "taps": 467,
        "imp_click_rate": "46.56%",
        "cli_price": 1.93,
        "installs": 379,
        "cli_installs_rate": "81.16%",
        "installs_price": 2.38
    },
    {
        "date": "2024/11/04",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 844.26,
        "impressions": 481,
        "ecpm": 1755.21,
        "taps": 268,
        "imp_click_rate": "55.72%",
        "cli_price": 3.15,
        "installs": 224,
        "cli_installs_rate": "83.58%",
        "installs_price": 3.77
    },
    {
        "date": "2024/11/04",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 45.91,
        "impressions": 111,
        "ecpm": 413.61,
        "taps": 14,
        "imp_click_rate": "12.61%",
        "cli_price": 3.28,
        "installs": 13,
        "cli_installs_rate": "92.86%",
        "installs_price": 3.53
    },
    {
        "date": "2024/11/04",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 7368.67,
        "impressions": 11660,
        "ecpm": 631.96,
        "taps": 523,
        "imp_click_rate": "4.49%",
        "cli_price": 14.09,
        "installs": 337,
        "cli_installs_rate": "64.44%",
        "installs_price": 21.87
    },
    {
        "date": "2024/11/04",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 194.54,
        "impressions": 459,
        "ecpm": 423.83,
        "taps": 14,
        "imp_click_rate": "3.05%",
        "cli_price": 13.9,
        "installs": 9,
        "cli_installs_rate": "64.29%",
        "installs_price": 21.62
    },
    {
        "date": "2024/11/04",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 336.3,
        "impressions": 388,
        "ecpm": 866.74,
        "taps": 26,
        "imp_click_rate": "6.70%",
        "cli_price": 12.93,
        "installs": 19,
        "cli_installs_rate": "73.08%",
        "installs_price": 17.7
    },
    {
        "date": "2024/11/04",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 18.38,
        "impressions": 29,
        "ecpm": 633.77,
        "taps": 2,
        "imp_click_rate": "6.90%",
        "cli_price": 9.19,
        "installs": 1,
        "cli_installs_rate": "50.00%",
        "installs_price": 18.38
    },
    {
        "date": "2024/11/03",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 28058.68,
        "impressions": 7566,
        "ecpm": 3708.52,
        "taps": 1269,
        "imp_click_rate": "16.77%",
        "cli_price": 22.11,
        "installs": 1018,
        "cli_installs_rate": "80.22%",
        "installs_price": 27.56
    },
    {
        "date": "2024/11/03",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 397.31,
        "impressions": 1637,
        "ecpm": 242.71,
        "taps": 28,
        "imp_click_rate": "1.71%",
        "cli_price": 14.19,
        "installs": 17,
        "cli_installs_rate": "60.71%",
        "installs_price": 23.37
    },
    {
        "date": "2024/11/03",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 7459.95,
        "impressions": 7048,
        "ecpm": 1058.45,
        "taps": 739,
        "imp_click_rate": "10.49%",
        "cli_price": 10.09,
        "installs": 600,
        "cli_installs_rate": "81.19%",
        "installs_price": 12.43
    },
    {
        "date": "2024/11/03",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 120.83,
        "impressions": 940,
        "ecpm": 128.54,
        "taps": 10,
        "imp_click_rate": "1.06%",
        "cli_price": 12.08,
        "installs": 8,
        "cli_installs_rate": "80.00%",
        "installs_price": 15.1
    },
    {
        "date": "2024/11/03",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 37961.81,
        "impressions": 38965,
        "ecpm": 974.25,
        "taps": 20711,
        "imp_click_rate": "53.15%",
        "cli_price": 1.83,
        "installs": 17148,
        "cli_installs_rate": "82.80%",
        "installs_price": 2.21
    },
    {
        "date": "2024/11/03",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 956.61,
        "impressions": 1041,
        "ecpm": 918.93,
        "taps": 496,
        "imp_click_rate": "47.65%",
        "cli_price": 1.93,
        "installs": 400,
        "cli_installs_rate": "80.65%",
        "installs_price": 2.39
    },
    {
        "date": "2024/11/03",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 950.77,
        "impressions": 567,
        "ecpm": 1676.84,
        "taps": 313,
        "imp_click_rate": "55.20%",
        "cli_price": 3.04,
        "installs": 264,
        "cli_installs_rate": "84.35%",
        "installs_price": 3.6
    },
    {
        "date": "2024/11/03",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 19.15,
        "impressions": 188,
        "ecpm": 101.89,
        "taps": 7,
        "imp_click_rate": "3.72%",
        "cli_price": 2.74,
        "installs": 6,
        "cli_installs_rate": "85.71%",
        "installs_price": 3.19
    },
    {
        "date": "2024/11/03",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 8932.09,
        "impressions": 12867,
        "ecpm": 694.19,
        "taps": 631,
        "imp_click_rate": "4.90%",
        "cli_price": 14.16,
        "installs": 399,
        "cli_installs_rate": "63.23%",
        "installs_price": 22.39
    },
    {
        "date": "2024/11/03",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 180.46,
        "impressions": 449,
        "ecpm": 401.91,
        "taps": 13,
        "imp_click_rate": "2.90%",
        "cli_price": 13.88,
        "installs": 9,
        "cli_installs_rate": "69.23%",
        "installs_price": 20.05
    },
    {
        "date": "2024/11/03",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 330.65,
        "impressions": 542,
        "ecpm": 610.06,
        "taps": 24,
        "imp_click_rate": "4.43%",
        "cli_price": 13.78,
        "installs": 13,
        "cli_installs_rate": "54.17%",
        "installs_price": 25.43
    },
    {
        "date": "2024/11/03",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 11.81,
        "impressions": 37,
        "ecpm": 319.24,
        "taps": 1,
        "imp_click_rate": "2.70%",
        "cli_price": 11.81,
        "installs": 1,
        "cli_installs_rate": "100.00%",
        "installs_price": 11.81
    },
    {
        "date": "2024/11/02",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 30354.77,
        "impressions": 8608,
        "ecpm": 3526.34,
        "taps": 1352,
        "imp_click_rate": "15.71%",
        "cli_price": 22.45,
        "installs": 1077,
        "cli_installs_rate": "79.66%",
        "installs_price": 28.18
    },
    {
        "date": "2024/11/02",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 465,
        "impressions": 1054,
        "ecpm": 441.17,
        "taps": 26,
        "imp_click_rate": "2.47%",
        "cli_price": 17.88,
        "installs": 18,
        "cli_installs_rate": "69.23%",
        "installs_price": 25.83
    },
    {
        "date": "2024/11/02",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 7948.55,
        "impressions": 6624,
        "ecpm": 1199.96,
        "taps": 754,
        "imp_click_rate": "11.38%",
        "cli_price": 10.54,
        "installs": 612,
        "cli_installs_rate": "81.17%",
        "installs_price": 12.99
    },
    {
        "date": "2024/11/02",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 183.27,
        "impressions": 1229,
        "ecpm": 149.12,
        "taps": 15,
        "imp_click_rate": "1.22%",
        "cli_price": 12.22,
        "installs": 12,
        "cli_installs_rate": "80.00%",
        "installs_price": 15.27
    },
    {
        "date": "2024/11/02",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 36370.48,
        "impressions": 37215,
        "ecpm": 977.31,
        "taps": 19685,
        "imp_click_rate": "52.90%",
        "cli_price": 1.85,
        "installs": 16221,
        "cli_installs_rate": "82.40%",
        "installs_price": 2.24
    },
    {
        "date": "2024/11/02",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 896.17,
        "impressions": 1000,
        "ecpm": 896.17,
        "taps": 464,
        "imp_click_rate": "46.40%",
        "cli_price": 1.93,
        "installs": 389,
        "cli_installs_rate": "83.84%",
        "installs_price": 2.3
    },
    {
        "date": "2024/11/02",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 896.51,
        "impressions": 479,
        "ecpm": 1871.62,
        "taps": 268,
        "imp_click_rate": "55.95%",
        "cli_price": 3.35,
        "installs": 218,
        "cli_installs_rate": "81.34%",
        "installs_price": 4.11
    },
    {
        "date": "2024/11/02",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 30.34,
        "impressions": 106,
        "ecpm": 286.26,
        "taps": 9,
        "imp_click_rate": "8.49%",
        "cli_price": 3.37,
        "installs": 8,
        "cli_installs_rate": "88.89%",
        "installs_price": 3.79
    },
    {
        "date": "2024/11/02",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 6119.84,
        "impressions": 10554,
        "ecpm": 579.86,
        "taps": 449,
        "imp_click_rate": "4.25%",
        "cli_price": 13.63,
        "installs": 261,
        "cli_installs_rate": "58.13%",
        "installs_price": 23.45
    },
    {
        "date": "2024/11/02",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 68.7,
        "impressions": 319,
        "ecpm": 215.35,
        "taps": 7,
        "imp_click_rate": "2.19%",
        "cli_price": 9.81,
        "installs": 5,
        "cli_installs_rate": "71.43%",
        "installs_price": 13.74
    },
    {
        "date": "2024/11/02",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 288.49,
        "impressions": 396,
        "ecpm": 728.51,
        "taps": 27,
        "imp_click_rate": "6.82%",
        "cli_price": 10.68,
        "installs": 22,
        "cli_installs_rate": "81.48%",
        "installs_price": 13.11
    },
    {
        "date": "2024/11/02",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 0,
        "impressions": 29,
        "ecpm": 0,
        "taps": 0,
        "imp_click_rate": "0.00%",
        "cli_price": 0,
        "installs": 0,
        "cli_installs_rate": "0.00%",
        "installs_price": 0
    },
    {
        "date": "2024/11/01",
        "ad_id": 1692401862,
        "ad_name": "行业词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 25708.66,
        "impressions": 10049,
        "ecpm": 2558.33,
        "taps": 1374,
        "imp_click_rate": "13.67%",
        "cli_price": 18.71,
        "installs": 1142,
        "cli_installs_rate": "83.11%",
        "installs_price": 22.51
    },
    {
        "date": "2024/11/01",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 470.87,
        "impressions": 1595,
        "ecpm": 295.21,
        "taps": 27,
        "imp_click_rate": "1.69%",
        "cli_price": 17.44,
        "installs": 21,
        "cli_installs_rate": "77.78%",
        "installs_price": 22.42
    },
    {
        "date": "2024/11/01",
        "ad_id": 1692430602,
        "ad_name": "行业词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 9712.7,
        "impressions": 7892,
        "ecpm": 1230.7,
        "taps": 915,
        "imp_click_rate": "11.59%",
        "cli_price": 10.61,
        "installs": 723,
        "cli_installs_rate": "79.02%",
        "installs_price": 13.43
    },
    {
        "date": "2024/11/01",
        "ad_id": 0,
        "ad_name": "58同城-行业词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 223.38,
        "impressions": 789,
        "ecpm": 283.12,
        "taps": 18,
        "imp_click_rate": "2.28%",
        "cli_price": 12.41,
        "installs": 16,
        "cli_installs_rate": "88.89%",
        "installs_price": 13.96
    },
    {
        "date": "2024/11/01",
        "ad_id": 1516269491,
        "ad_name": "品牌词-核心-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 36562.86,
        "impressions": 37350,
        "ecpm": 978.93,
        "taps": 19970,
        "imp_click_rate": "53.47%",
        "cli_price": 1.83,
        "installs": 16428,
        "cli_installs_rate": "82.26%",
        "installs_price": 2.23
    },
    {
        "date": "2024/11/01",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 935.66,
        "impressions": 952,
        "ecpm": 982.84,
        "taps": 490,
        "imp_click_rate": "51.47%",
        "cli_price": 1.91,
        "installs": 393,
        "cli_installs_rate": "80.20%",
        "installs_price": 2.38
    },
    {
        "date": "2024/11/01",
        "ad_id": 1516269753,
        "ad_name": "品牌词-长尾-58品牌词组",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 812.05,
        "impressions": 421,
        "ecpm": 1928.86,
        "taps": 253,
        "imp_click_rate": "60.10%",
        "cli_price": 3.21,
        "installs": 212,
        "cli_installs_rate": "83.79%",
        "installs_price": 3.83
    },
    {
        "date": "2024/11/01",
        "ad_id": 0,
        "ad_name": "58同城-品牌词-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 23.48,
        "impressions": 48,
        "ecpm": 489.24,
        "taps": 5,
        "imp_click_rate": "10.42%",
        "cli_price": 4.7,
        "installs": 4,
        "cli_installs_rate": "80.00%",
        "installs_price": 5.87
    },
    {
        "date": "2024/11/01",
        "ad_id": 1692430564,
        "ad_name": "竞品词-招聘-长尾-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 5432.67,
        "impressions": 9149,
        "ecpm": 593.8,
        "taps": 392,
        "imp_click_rate": "4.28%",
        "cli_price": 13.86,
        "installs": 249,
        "cli_installs_rate": "63.52%",
        "installs_price": 21.82
    },
    {
        "date": "2024/11/01",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-长尾-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 111.94,
        "impressions": 313,
        "ecpm": 357.63,
        "taps": 8,
        "imp_click_rate": "2.56%",
        "cli_price": 13.99,
        "installs": 4,
        "cli_installs_rate": "50.00%",
        "installs_price": 27.98
    },
    {
        "date": "2024/11/01",
        "ad_id": 1692431402,
        "ad_name": "竞品词-招聘-核心-第16期秋日招聘找工作",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 259.28,
        "impressions": 363,
        "ecpm": 714.26,
        "taps": 18,
        "imp_click_rate": "4.96%",
        "cli_price": 14.4,
        "installs": 10,
        "cli_installs_rate": "55.56%",
        "installs_price": 25.93
    },
    {
        "date": "2024/11/01",
        "ad_id": 0,
        "ad_name": "58同城-竞品词-招聘-核心-Default Ad",
        "app_name": "58同城",
        "app_id": 480079300,
        "local_spend": 17.46,
        "impressions": 33,
        "ecpm": 529.02,
        "taps": 1,
        "imp_click_rate": "3.03%",
        "cli_price": 17.46,
        "installs": 1,
        "cli_installs_rate": "100.00%",
        "installs_price": 17.46
    }
]
